var xxx, ccc;
window.theme = window.theme || {}, window.home_video_list = window.home_video_list || {}, window.theme = window.theme || {}, theme.Sections = function () {
        this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
    }, theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
        _createInstance: function (p, v) {
            var y = $(p),
                b = y.attr("data-section-id"),
                C = y.attr("data-section-type");
            if (v = v || this.constructors[C], !_.isUndefined(v)) {
                var k = _.assignIn(new v(p), {
                    id: b,
                    type: C,
                    container: p
                });
                this.instances.push(k)
            }
        },
        _onSectionLoad: function (p) {
            var v = $("[data-section-id]", p.target)[0];
            v && this._createInstance(v)
        },
        _onSectionUnload: function (p) {
            this.instances = _.filter(this.instances, function (v) {
                var y = v.id === p.detail.sectionId;
                return y && _.isFunction(v.onUnload) && v.onUnload(p), !y
            })
        },
        _onSelect: function (p) {
            var v = _.find(this.instances, function (y) {
                return y.id === p.detail.sectionId
            });
            !_.isUndefined(v) && _.isFunction(v.onSelect) && v.onSelect(p)
        },
        _onDeselect: function (p) {
            var v = _.find(this.instances, function (y) {
                return y.id === p.detail.sectionId
            });
            !_.isUndefined(v) && _.isFunction(v.onDeselect) && v.onDeselect(p)
        },
        _onBlockSelect: function (p) {
            var v = _.find(this.instances, function (y) {
                return y.id === p.detail.sectionId
            });
            !_.isUndefined(v) && _.isFunction(v.onBlockSelect) && v.onBlockSelect(p)
        },
        _onBlockDeselect: function (p) {
            var v = _.find(this.instances, function (y) {
                return y.id === p.detail.sectionId
            });
            !_.isUndefined(v) && _.isFunction(v.onBlockDeselect) && v.onBlockDeselect(p)
        },
        register: function (p, v) {
            this.constructors[p] = v, $("[data-section-type=" + p + "]").each(function (y, b) {
                this._createInstance(b, v)
            }.bind(this))
        }
    }), window.slate = window.slate || {}, slate.rte = {
        wrapTable: function () {
            $(".rte table").wrap("<div class=\"rte__table-wrapper\"></div>")
        },
        iframeReset: function () {
            var p = $(".rte iframe[src*=\"youtube.com/embed\"], .rte iframe[src*=\"player.vimeo\"]"),
                v = p.add(".rte iframe#admin_bar_iframe");
            p.each(function () {
                $(this).wrap("<div class=\"video-wrapper\"></div>")
            }), v.each(function () {
                this.src = this.src
            })
        }
    }, window.slate = window.slate || {}, slate.a11y = {
        pageLinkFocus: function (p) {
            var y = "js-focus-hidden";
            p.first().attr("tabIndex", "-1").focus().addClass(y).one("blur", function () {
                p.first().removeClass(y).removeAttr("tabindex")
            })
        },
        focusHash: function () {
            var p = window.location.hash;
            p && document.getElementById(p.slice(1)) && this.pageLinkFocus($(p))
        },
        bindInPageLinks: function () {
            $("a[href*=#]").on("click", function (p) {
                this.pageLinkFocus($(p.currentTarget.hash))
            }.bind(this))
        },
        trapFocus: function (p) {
            var v = p.namespace ? "focusin." + p.namespace : "focusin";
            p.$elementToFocus || (p.$elementToFocus = p.$container), p.$container.attr("tabindex", "-1"), p.$elementToFocus.focus(), $(document).off("focusin"), $(document).on(v, function (y) {
                p.$container[0] === y.target || p.$container.has(y.target).length || p.$container.focus()
            })
        },
        removeTrapFocus: function (p) {
            var v = p.namespace ? "focusin." + p.namespace : "focusin";
            p.$container && p.$container.length && p.$container.removeAttr("tabindex"), $(document).off(v)
        }
    }, theme.Images = function () {
        return {
            preload: function (S, I) {
                "string" == typeof S && (S = [S]);
                for (var x, T = 0; T < S.length; T++) x = S[T], this.loadImage(this.getSizedImageUrl(x, I))
            },
            loadImage: function (S) {
                new Image().src = S
            },
            switchImage: function (S, I, T) {
                var x = this.imageSize(I.src),
                    P = this.getSizedImageUrl(S.src, x);
                T ? T(P, S, I) : I.src = P
            },
            imageSize: function (S) {
                var I = S.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                return null === I ? null : I[1]
            },
            getSizedImageUrl: function (S, I) {
                if (null == I) return S;
                if ("master" === I) return this.removeProtocol(S);
                var T = S.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null != T) {
                    var x = S.split(T[0]),
                        P = T[0];
                    return this.removeProtocol(x[0] + "_" + I + P)
                }
                return null
            },
            removeProtocol: function (S) {
                return S.replace(/http(s)?:/, "")
            }
        }
    }(), theme.Currency = function () {
        return {
            formatMoney: function (y, b) {
                function C(T, x, P, N) {
                    if (x = x || 2, P = P || ",", N = N || ".", isNaN(T) || null == T) return 0;
                    T = (T / 100).toFixed(x);
                    var B = T.split("."),
                        A = B[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + P),
                        z = B[1] ? N + B[1] : "";
                    return A
                }
                "string" == typeof y && (y = y.replace(".", ""));
                var k = "",
                    S = /\{\{\s*(\w+)\s*\}\}/,
                    I = b || "${{amount}}";
                switch (I.match(S)[1]) {
                    case "amount":
                        k = C(y, 2);
                        break;
                    case "amount_no_decimal":
                        k = C(y, 0);
                        break;
                    case "amount_no_decimals":
                        k = C(y, 0);
                        break;
                    case "amount_with_comma_separator":
                        k = C(y, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        k = C(y, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        k = C(y, 0, " ");
                }
                return I.replace(S, k)
            }
        }
    }(), slate.Variants = function () {
        function p(v) {
            this.$container = v.$container, this.product = v.product, this.singleOptionSelector = v.singleOptionSelector, this.originalSelectorId = v.originalSelectorId, this.enableHistoryState = v.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
        }
        return p.prototype = _.assignIn({}, p.prototype, {
            _getCurrentOptions: function () {
                var v = _.map($(this.singleOptionSelector, this.$container), function (y) {
                    var b = $(y),
                        C = b.attr("type"),
                        k = {};
                    return "radio" === C || "checkbox" === C ? !!b[0].checked && (k.value = b.val(), k.index = b.data("index"), k) : (k.value = b.val(), k.index = b.data("index"), k)
                });
                return v = _.compact(v), v
            },
            _getVariantFromOptions: function () {
                var v = this._getCurrentOptions(),
                    y = this.product.variants,
                    b = _.find(y, function (C) {
                        return v.every(function (k) {
                            return _.isEqual(C[k.index], k.value)
                        })
                    });
                return b
            },
            _onSelectChange: function () {
                var v = this._getVariantFromOptions();
                this.$container.trigger({
                    type: "variantChange",
                    variant: v
                }), v && (this._updateMasterSelect(v), this._updateImages(v), this._updatePrice(v), this._updateSKU(v), this.currentVariant = v, this.enableHistoryState && this._updateHistoryState(v))
            },
            _updateImages: function (v) {
                var y = v.featured_image || {},
                    b = this.currentVariant.featured_image || {};
                v.featured_image && y.src !== b.src && this.$container.trigger({
                    type: "variantImageChange",
                    variant: v
                })
            },
            _updatePrice: function (v) {
                v.price === this.currentVariant.price && v.compare_at_price === this.currentVariant.compare_at_price || this.$container.trigger({
                    type: "variantPriceChange",
                    variant: v
                })
            },
            _updateSKU: function (v) {
                v.sku === this.currentVariant.sku || this.$container.trigger({
                    type: "variantSKUChange",
                    variant: v
                })
            },
            _updateHistoryState: function (v) {
                if (history.replaceState && v) {
                    var y = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + v.id;
                    window.history.replaceState({
                        path: y
                    }, "", y)
                }
            },
            _updateMasterSelect: function (v) {
                $(this.originalSelectorId, this.$container).val(v.id)
            }
        }), p
    }(), theme.Drawers = function () {
        function p(v, y, b) {
            return this.nodes = {
                $parent: $("html").add("body"),
                $page: $("#PageContainer")
            }, this.config = $.extend({
                close: ".js-drawer-close",
                open: ".js-drawer-open-" + y,
                openClass: "js-drawer-open",
                dirOpenClass: "js-drawer-open-" + y
            }, b), this.position = y, this.$drawer = $("#" + v), !!this.$drawer.length && void(this.drawerIsOpen = !1, this.init())
        }
        return p.prototype.init = function () {
            $(this.config.open).on("click", $.proxy(this.open, this)), this.$drawer.on("click", this.config.close, $.proxy(this.close, this))
        }, p.prototype.open = function (v) {
            var y = !1;
            return (v ? v.preventDefault() : y = !0, v && v.stopPropagation && (v.stopPropagation(), this.$activeSource = $(v.currentTarget)), this.drawerIsOpen && !y) ? this.close() : (this.$drawer.prepareTransition(), this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass), this.drawerIsOpen = !0, slate.a11y.trapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus"
            }), this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && !y && this.config.onDrawerOpen(), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), this.bindEvents(), this)
        }, p.prototype.close = function () {
            this.drawerIsOpen && ($(document.activeElement).trigger("blur"), this.$drawer.prepareTransition(), this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass), this.drawerIsOpen = !1, slate.a11y.removeTrapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus"
            }), this.unbindEvents())
        }, p.prototype.bindEvents = function () {
            this.nodes.$parent.on("keyup.drawer", $.proxy(function (v) {
                return 27 !== v.keyCode || (this.close(), !1)
            }, this)), this.nodes.$page.on("touchmove.drawer", function () {
                return !1
            }), this.nodes.$page.on("click.drawer", $.proxy(function () {
                return this.close(), !1
            }, this))
        }, p.prototype.unbindEvents = function () {
            this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer")
        }, p
    }(), window.theme = window.theme || {}, theme.Header = function () {
        function p() {}

        function v() {
            $(".sub-active").closest(".parent-menu-item").addClass("current-menu-ancestor")
        }

        function y() {
            $(document.body).hasClass("sticky-header") && ($(window).on("scroll", function () {
                var k = 5;
                $(document.body).hasClass("header-slider-top") && (k = $("#header-slider").height() + $("#un-header-minimized").height()), $(window).scrollTop() > k ? ($(C.header).addClass("minimized"), $(document.body).addClass("sticky-header-show")) : ($(C.header).removeClass("minimized"), $(document.body).removeClass("sticky-header-show"))
            }), $(window).on("resize", function () {
                if (768 > $(window).width()) {
                    var k = $(C.header).height();
                    $("#un-header-minimized").height(k)
                } else $("#un-header-minimized").removeAttr("style")
            }).trigger("resize"))
        }
        var C = {
            header: ".site-header",
            navigation: "ul#menu-primary-header"
        };
        return {
            init: function () {
                $(C.header).length && (p(), v(), y())
            }
        }
    }(), window.theme = window.theme || {}, theme.Search = function () {
        function p() {}

        function v() {
            function C() {
                var B = P.val(),
                    A = "";
                if (0 < T.find(".product-cats").length && (A = T.find(".product-cats input:checked").val()), 2 > B.length) return void T.removeClass("searching found-products found-no-product").addClass("invalid-length");
                T.removeClass("found-products found-no-product").addClass("searching");
                var z = B + A;
                if (z in I) {
                    var D = I[z];
                    T.removeClass("searching"), T.addClass("found-products"), N.find(".rt-unero").html(D.products), $(document.body).trigger("unero_ajax_search_request_success", [N]), N.find(".rt-unero, .buttons").slideDown(function () {
                        T.removeClass("invalid-length")
                    }), T.addClass("searched actived")
                } else {
                    var U = "/search?view=ajax&" + x.serialize();
                    S = $.get(U, function (O) {
                        ccc = O;
                        var q = $(O).html();
                        T.removeClass("searching"), T.addClass("found-products"), N.find(".rt-unero").html(q), N.find(".rt-unero, .buttons").slideDown(function () {
                            T.removeClass("invalid-length")
                        }), $(document.body).trigger("unero_ajax_search_request_success", [N]), I[z] = {
                            found: !0,
                            products: q
                        }, T.addClass("searched actived")
                    })
                }
                $(document.body).on("unero_ajax_search_request_success", function (O, q) {
                    q.find("img.lazy").lazyload({
                        threshold: 1e3
                    })
                })
            }
            var S = null,
                I = {},
                T = $("#search-modal"),
                x = T.find("form"),
                P = x.find("input.search-field"),
                N = T.find(".search-results");
            T.on("keyup", ".search-field", function (B) {
                    var A = !1;
                    "undefined" == typeof B.which ? A = !0 : "number" == typeof B.which && 0 < B.which && (A = !B.ctrlKey && !B.metaKey && !B.altKey);
                    A && (S && S.abort(), C())
                }).on("change", ".product-cats input", function () {
                    S && S.abort(), C()
                }).on("focusout", ".search-field", function () {
                    2 > P.val().length && N.find(".rt-unero, .buttons").slideUp(function () {
                        T.removeClass("searching searched actived found-products found-no-product invalid-length")
                    })
                }),
                function () {
                    var B = $(".header-layout-4").find("#search-modal"),
                        A = B.find("input.search-field");
                    0 >= B.length || ($(window).on("scroll", function () {
                        10 < $(window).scrollTop() && B.removeClass("show found-products searched")
                    }), $(document).on("click", function (z) {
                        var D = z.target;
                        $(D).closest(".extra-menu-item").hasClass("menu-item-search") || B.removeClass("searching searched found-products found-no-product invalid-length")
                    }), B.on("click", ".t-icon", function (z) {
                        B.hasClass("actived") && (z.preventDefault(), A.val(""), B.removeClass("searching searched actived found-products found-no-product invalid-length"))
                    }))
                }()
        }
        var b = {
            search: "#search-modal"
        };
        return {
            init: function () {
                $(b.search).length && (p(), v())
            }
        }
    }(), window.theme = window.theme || {}, theme.CurrencyPicker = function () {
        function p() {
            var k = $(b.currency).first().closest(".currency-wrapper");
            C.currency_format = k.find(".currency_format").val(), C.shop_currency = k.find(".shop_currency").val(), C.default_currency = k.find(".default_currency").val(), C.money_with_currency_format = k.find(".money_with_currency_format").val(), C.money_format = k.find(".money_format").val(), Currency.format = C.currency_format;
            var S = C.shop_currency;
            Currency.moneyFormats[S].money_with_currency_format = C.money_with_currency_format, Currency.moneyFormats[S].money_format = C.money_format;
            var I = C.default_currency;
            try {
                var T = Currency.cookie.read();
                $("span.money span.money").each(function () {
                    $(this).parents("span.money").removeClass("money")
                }), $("span.money").each(function () {
                    $(this).attr("data-currency-" + C.shop_currency, $(this).html())
                }), null == T ? (S === I ? Currency.currentCurrency = I : Currency.convertAll(S, I), Currency.cookie.write(I)) : $(b.currency).length && 0 === $(b.currency + " .currency[data-code=" + T + "]").size() ? (Currency.currentCurrency = S, Currency.cookie.write(S)) : T === S ? Currency.currentCurrency = S : Currency.convertAll(S, T), $(b.currency).on("click", ".currency:not(.active)", function () {
                    var N = $(this).attr("data-code");
                    Currency.convertAll(Currency.currentCurrency, N), $(b.currencyPicker).removeClass("active"), $(b.currencyPicker).closest("li").removeClass("actived"), $(this).addClass("active"), $(this).closest("li").addClass("actived"), $(".menu-item-currency.currency-wrapper").find("span.current").html($(this).html() + "<span class=\"toggle-children i-icon arrow_carrot-down\"></span>")
                });
                var x = window.selectCallback;
                $("body").on("ajaxCart.afterCartLoad", function () {
                    Currency.convertAll(S, $(b.currencyActive).attr("data-code")), $(b.currencyPicker).removeClass("active"), $(b.currencyPicker).closest("li").removeClass("actived"), $(b.currency + " .currency[data-code=" + Currency.currentCurrency + "]").addClass("active"), $(b.currency + " .currency[data-code=" + Currency.currentCurrency + "]").closest("li").addClass("actived"), $(".menu-item-currency.currency-wrapper").find("span.current").html(Currency.currentCurrency + "<span class=\"toggle-children i-icon arrow_carrot-down\"></span>")
                }), $(b.currencyPicker).removeClass("active"), $(b.currencyPicker).closest("li").removeClass("actived"), $(b.currency + " .currency[data-code=" + Currency.currentCurrency + "]").addClass("active"), $(b.currency + " .currency[data-code=" + Currency.currentCurrency + "]").closest("li").addClass("actived"), $(".menu-item-currency.currency-wrapper").find("span.current").html(Currency.currentCurrency + "<span class=\"toggle-children i-icon arrow_carrot-down\"></span>")
            } catch (N) {
                console.log(N.message)
            }
        }
        var b = {
                currency: ".currency_switcher",
                currencyPicker: ".currency_switcher .currency",
                currencyActive: ".currency_switcher .currency.active"
            },
            C = {
                currency_format: "",
                shop_currency: "",
                default_currency: "",
                money_with_currency_format: "",
                money_format: ""
            };
        return {
            init: function () {
                $(b.currency).length && p()
            },
            convert: function (k) {
                if ($(b.currency).length) try {
                    $(k).each(function () {
                        $(this).attr("data-currency-" + C.shop_currency, $(this).html())
                    }), Currency.convertAll(C.shop_currency, Currency.cookie.read(), k, C.currency_format)
                } catch (S) {
                    console.log(S.message)
                }
            }
        }
    }(),
    function () {
        function p(b) {
            var C = document.createElement("a");
            return C.ref = b, C.hostname
        }
        var y = $({
            backButton: ".return-link"
        }.backButton);
        document.referrer && y.length && window.history.length && y.one("click", function (b) {
            b.preventDefault();
            var C = p(document.referrer),
                k = p(window.location.href);
            return k === C && history.back(), !1
        })
    }(), theme.Slideshow = function () {
        function p(T) {
            this.$slideshow = $(T), this.$wrapper = this.$slideshow.closest("." + I.wrapper), this.$pause = this.$wrapper.find("." + I.pauseButton), this.settings = {
                accessibility: !0,
                arrows: !0,
                dots: !1,
                fade: !0,
                draggable: !0,
                touchThreshold: 20,
                autoplay: this.$slideshow.data("autoplay"),
                autoplaySpeed: this.$slideshow.data("speed")
            }, this.$slideshow.on("beforeChange", C.bind(this)), this.$slideshow.on("init", b.bind(this)), this.$slideshow.slick(this.settings), this.$pause.on("click", this.togglePause.bind(this)), v()
        }

        function v() {
            function T() {
                var x = $(window).height();
                $("." + I.slideshowWindow).css("height", x)
            }
            $("." + I.slideshowWindow).length && (T(), $(window).on("resize", function () {
                T()
            }))
        }

        function b(T, x) {
            var P = x.$slider,
                N = x.$list,
                B = this.$wrapper,
                A = this.settings.autoplay;
            N.removeAttr("aria-live"), B.on("focusin", function (z) {
                B.has(z.target).length && (N.attr("aria-live", "polite"), A && P.slick("slickPause"))
            }), B.on("focusout", function (z) {
                if (B.has(z.target).length && (N.removeAttr("aria-live"), A)) {
                    if ($(z.target).hasClass(I.closeVideoBtn)) return;
                    P.slick("slickPlay")
                }
            }), x.$dots && x.$dots.on("keydown", function (z) {
                37 === z.which && P.slick("slickPrev"), 39 === z.which && P.slick("slickNext"), (37 === z.which || 39 === z.which) && x.$dots.find(".slick-active button").focus()
            })
        }

        function C(T, x, P, N) {
            var B = x.$slider,
                A = B.find("." + I.currentSlide),
                z = B.find(".slideshow__slide[data-slick-index=\"" + N + "\"]");
            if (k(A)) {
                var D = A.find("." + I.video),
                    U = D.attr("id");
                theme.SlideshowVideo.pauseVideo(U), D.attr("tabindex", "-1")
            }
            if (k(z)) {
                var O = z.find("." + I.video),
                    q = O.attr("id"),
                    M = O.hasClass(I.videoBackground);
                M ? theme.SlideshowVideo.playVideo(q) : O.attr("tabindex", "0")
            }
        }

        function k(T) {
            return T.find("." + I.video).length
        }

        function S(T) {
            return "#Slideshow-" + T.data("id")
        }
        this.$slideshow = null;
        var I = {
            wrapper: "slideshow-wrapper",
            slideshow: "slideshow",
            slideshowWindow: "slideshow--window",
            imageBackground: "slideshow__image",
            currentSlide: "slick-current",
            video: "slideshow__video",
            videoBackground: "slideshow__video--background",
            closeVideoBtn: "slideshow__video-control--close",
            pauseButton: "slideshow__pause",
            isPaused: "is-paused"
        };
        return p.prototype.togglePause = function () {
            var T = S(this.$pause);
            this.$pause.hasClass(I.isPaused) ? (this.$pause.removeClass(I.isPaused), $(T).slick("slickPlay")) : (this.$pause.addClass(I.isPaused), $(T).slick("slickPause"))
        }, p
    }();

function onYouTubeIframeAPIReady() {
    theme.SlideshowVideo.loadVideos()
}
theme.SlideshowVideo = function () {
        function k(X, ee) {
            var te = Q[X],
                ae = Y[X],
                oe = Q[X].$parentSlide;
            if (G) A(te);
            else if (ee || F && R) return oe.removeClass(J.loading), A(te), void ae.playVideo();
            F || I(ae, oe)
        }

        function S(X) {
            var ee = X ? J.supportsAutoplay : J.supportsNoAutoplay;
            $(document.documentElement).addClass(ee), X || (G = !0), F = !0
        }

        function I(X, ee) {
            X.playVideo(), T(X).then(function () {
                S(!0)
            }).fail(function () {
                S(!1), X.stopVideo()
            }).always(function () {
                F = !0, ee.removeClass(J.loading)
            })
        }

        function T(X) {
            var te, ae, ee = $.Deferred();
            return te = setInterval(function () {
                0 >= X.getCurrentTime() || (R = !0, clearInterval(te), clearTimeout(ae), ee.resolve())
            }, 500), ae = setTimeout(function () {
                clearInterval(te), ee.reject()
            }, 4e3), ee
        }

        function x() {
            W || (750 > $(window).width() ? G = !0 : window.mobileCheck() && (G = !0), G && S(!1), W = !0)
        }

        function B(X) {
            switch (X.type) {
                case "background":
                    Y[X.id].seekTo(0);
                    break;
                case "background-chrome":
                    Y[X.id].seekTo(0), D(X.id);
                    break;
                case "chrome":
                    D(X.id);
            }
        }

        function A(X) {
            var ee = X.$parentSlideshowWrapper,
                te = X.$parentSlide;
            if (te.removeClass(J.loading), "background" !== X.status) {
                switch ($("#" + X.id).attr("tabindex", "0"), X.type) {
                    case "chrome":
                    case "background-chrome":
                        ee.removeClass(J.paused).addClass(J.playing), te.removeClass(J.paused).addClass(J.playing);
                }
                te.find("." + J.closeVideoBtn).focus()
            }
        }

        function z(X) {
            var ee = X.$parentSlideshowWrapper,
                te = X.$parentSlide;
            return "background-chrome" === X.type ? void D(X.id) : void("closed" !== X.status && "background" !== X.type && (ee.addClass(J.paused), te.addClass(J.paused)), "chrome" === X.type && "closed" === X.status && (ee.removeClass(J.paused), te.removeClass(J.paused)), ee.removeClass(J.playing), te.removeClass(J.playing))
        }

        function D(X) {
            var ee = Q[X],
                te = ee.$parentSlideshowWrapper,
                ae = ee.$parentSlide,
                oe = [J.pause, J.playing].join(" ");
            switch ($("#" + ee.id).attr("tabindex", "-1"), ee.status = "closed", ee.type) {
                case "background-chrome":
                    Y[X].mute(), L(X);
                    break;
                case "chrome":
                    Y[X].stopVideo(), z(ee);
            }
            te.removeClass(oe), ae.removeClass(oe)
        }

        function U(X) {
            return Q[X.target.h.id]
        }

        function O(X) {
            var ee = Q[X];
            switch (ee.$parentSlide.addClass(J.loading), ee.status = "open", ee.type) {
                case "background-chrome":
                    V(X, ee), Y[X].unMute(), k(X, !0);
                    break;
                case "chrome":
                    k(X, !0);
            }
            $(document).on("keydown.videoPlayer", function (te) {
                27 === te.keyCode && D(X)
            })
        }

        function q() {
            $("." + J.videoBackground).each(function (X, ee) {
                M($(ee))
            })
        }

        function M(X) {
            var ee = X.closest("." + J.slide);
            if (!ee.hasClass(J.slickClone)) {
                var te = ee.width(),
                    ae = X.width(),
                    oe = X.height();
                te / Z.ratio < oe ? (ae = Math.ceil(oe * Z.ratio), X.width(ae).height(oe).css({
                    left: (te - ae) / 2,
                    top: 0
                })) : (oe = Math.ceil(te / Z.ratio), X.width(te).height(oe).css({
                    left: 0,
                    top: (oe - oe) / 2
                })), X.prepareTransition().addClass(J.loaded)
            }
        }

        function V(X) {
            $("#" + X).removeAttr("style").removeClass(J.videoBackground).addClass(J.videoChrome), Q[X].$parentSlideshowWrapper.removeClass(J.slideBackgroundVideo).addClass(J.playing), Q[X].$parentSlide.removeClass(J.slideBackgroundVideo).addClass(J.playing), Q[X].status = "open"
        }

        function L(X) {
            var ee = $("#" + X).addClass(J.videoBackground).removeClass(J.videoChrome);
            Q[X].$parentSlide.addClass(J.slideBackgroundVideo), Q[X].status = "background", M(ee)
        }

        function E() {
            $(document).on("click.videoPlayer", "." + J.playVideoBtn, function (X) {
                var ee = $(X.currentTarget).data("controls");
                O(ee)
            }), $(document).on("click.videoPlayer", "." + J.closeVideoBtn, function (X) {
                var ee = $(X.currentTarget).data("controls");
                D(ee)
            }), $(window).on("resize.videoPlayer", $.debounce(250, function () {
                K && q()
            }))
        }
        var F = !1,
            R = !1,
            W = !1,
            G = !1,
            K = !1,
            Q = {},
            Y = [],
            Z = {
                ratio: 16 / 9,
                playerVars: {
                    iv_load_policy: 3,
                    modestbranding: 1,
                    autoplay: 0,
                    controls: 0,
                    showinfo: 0,
                    wmode: "opaque",
                    branding: 0,
                    autohide: 0,
                    rel: 0
                },
                events: {
                    onReady: function (X) {
                        X.target.setPlaybackQuality("hd1080");
                        var ee = U(X);
                        switch (x(), $("#" + ee.id).attr("tabindex", "-1"), q(), ee.type) {
                            case "background-chrome":
                            case "background":
                                X.target.mute(), ee.$parentSlide.hasClass(J.currentSlide) && k(ee.id);
                        }
                        ee.$parentSlide.addClass(J.loaded)
                    },
                    onStateChange: function (X) {
                        var ee = U(X);
                        switch (X.data) {
                            case 0:
                                B(ee);
                                break;
                            case 1:
                                A(ee);
                                break;
                            case 2:
                                z(ee);
                        }
                    }
                }
            },
            J = {
                playing: "video-is-playing",
                paused: "video-is-paused",
                loading: "video-is-loading",
                loaded: "video-is-loaded",
                slideshowWrapper: "slideshow-wrapper",
                slide: "slideshow__slide",
                slideBackgroundVideo: "slideshow__slide--background-video",
                slideDots: "slick-dots",
                videoChrome: "slideshow__video--chrome",
                videoBackground: "slideshow__video--background",
                playVideoBtn: "slideshow__video-control--play",
                closeVideoBtn: "slideshow__video-control--close",
                currentSlide: "slick-current",
                slickClone: "slick-cloned",
                supportsAutoplay: "autoplay",
                supportsNoAutoplay: "no-autoplay"
            };
        return {
            init: function (X) {
                if (X.length && (Q[X.attr("id")] = {
                        id: X.attr("id"),
                        videoId: X.data("id"),
                        type: X.data("type"),
                        status: "chrome" === X.data("type") ? "closed" : "background",
                        videoSelector: X.attr("id"),
                        $parentSlide: X.closest("." + J.slide),
                        $parentSlideshowWrapper: X.closest("." + J.slideshowWrapper),
                        controls: "background" === X.data("type") ? 0 : 1,
                        slideshow: X.data("slideshow")
                    }, !K)) {
                    var ee = document.createElement("script");
                    ee.src = "https://www.youtube.com/iframe_api";
                    var te = document.getElementsByTagName("script")[0];
                    te.parentNode.insertBefore(ee, te)
                }
            },
            loadVideos: function () {
                for (var X in Q)
                    if (Q.hasOwnProperty(X)) {
                        var ee = $.extend({}, Z, Q[X]);
                        ee.playerVars.controls = ee.controls, Y[X] = new YT.Player(X, ee)
                    } E(), K = !0
            },
            loadVideo: function (X) {
                if (K) {
                    var ee = $.extend({}, Z, Q[X]);
                    ee.playerVars.controls = ee.controls, Y[X] = new YT.Player(X, ee), E()
                }
            },
            playVideo: function (X) {
                (W || G) && (!X || "function" != typeof Y[X].playVideo || k(X))
            },
            pauseVideo: function (X) {
                Y[X] && "function" == typeof Y[X].pauseVideo && Y[X].pauseVideo()
            },
            removeEvents: function () {
                $(document).off(".videoPlayer"), $(window).off(".videoPlayer")
            }
        }
    }(),
    function () {
        var p = $("#BlogTagFilter");
        p.length && p.on("change", function () {
            location.href = $(this).val()
        })
    }(), window.theme = theme || {}, theme.customerTemplates = function () {
        function p() {
            $("#RecoverPassword").on("click", function (b) {
                b.preventDefault(), $("#forgot-pass-tab").trigger("click")
            }), $("#HideRecoverPasswordLink").on("click", function (b) {
                b.preventDefault(), $("#login-tab").trigger("click")
            })
        }

        function v() {
            var b = $(".reset-password-success");
            b.length && $("#ResetSuccess").removeClass("hide")
        }

        function y() {
            var b = $("#AddressNewForm");
            b.length && (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
                hideElement: "AddressProvinceContainerNew"
            }), $(".address-country-option").each(function () {
                var C = $(this).data("form-id");
                new Shopify.CountryProvinceSelector("AddressCountry_" + C, "AddressProvince_" + C, {
                    hideElement: "AddressProvinceContainer_" + C
                })
            }), $(".address-new-toggle").on("click", function () {
                b.toggleClass("hide")
            }), $(".address-edit-toggle").on("click", function () {
                var C = $(this).data("form-id");
                $("#EditAddress_" + C).toggleClass("hide")
            }), $(".address-delete").on("click", function () {
                var C = $(this),
                    k = C.data("form-id"),
                    S = C.data("confirm-message");
                confirm(S || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + k, {
                    parameters: {
                        _method: "delete"
                    }
                })
            }))
        }
        return {
            init: function () {
                p(), v(), y()
            }
        }
    }(), window.theme = window.theme || {}, theme.HeaderSection = function () {
        return function () {
            theme.Header.init(), theme.Search.init(), theme.CurrencyPicker.init()
        }
    }(), theme.Maps = function () {
        function p(I) {
            this.$container = $(I), "loaded" === C ? this.createMap() : (k.push(this), "loading" != C && (C = "loading", "undefined" == typeof window.google && $.getScript("https://maps.googleapis.com/maps/api/js?key=" + S).then(function () {
                C = "loaded", v()
            })))
        }

        function v() {
            $.each(k, function (I, T) {
                T.createMap()
            })
        }

        function y(I) {
            var T = $.Deferred(),
                x = new google.maps.Geocoder,
                P = I.data("address-setting");
            return x.geocode({
                address: P
            }, function (N, B) {
                B !== google.maps.GeocoderStatus.OK && T.reject(B), T.resolve(N)
            }), T
        }
        var b = {
                zoom: 14
            },
            C = null,
            k = [],
            S = theme.mapKey ? theme.mapKey : "";
        return p.prototype = _.assignIn({}, p.prototype, {
            createMap: function () {
                var I = this.$container.find(".map-section__container");
                return y(I).then(function (T) {
                    var x = {
                            mapTypeId: "terrain",
                            zoom: b.zoom,
                            center: T[0].geometry.location,
                            disableDefaultUI: !0
                        },
                        P = this.map = new google.maps.Map(I[0], x),
                        N = this.center = P.getCenter(),
                        B = new google.maps.Marker({
                            map: P,
                            position: P.getCenter()
                        });
                    google.maps.event.addDomListener(window, "resize", $.debounce(250, function () {
                        google.maps.event.trigger(P, "resize"), P.setCenter(N)
                    }))
                }.bind(this)).fail(function () {
                    var T;
                    T = "ZERO_RESULTS" === status ? theme.strings.addressNoResults : "OVER_QUERY_LIMIT" === status ? theme.strings.addressQueryLimit : theme.strings.addressError, I.parent().addClass("map-section--load-error").html("<div class=\"errors text-center\">" + T + "</div>")
                })
            },
            onUnload: function () {
                google.maps.event.clearListeners(this.map, "resize")
            }
        }), p
    }();

function gm_authFailure() {
    $(".map-section").addClass("map-section--load-error"), $(".map-section__container").remove(), $(".map-section__link").remove(), $(".map-section__overlay").after("<div class=\"errors text-center\">" + theme.strings.authError + "</div>")
}
theme.Product = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.settings = {
            mediaQueryMediumUp: "screen and (min-width: 750px)",
            mediaQuerySmall: "screen and (max-width: 749px)",
            bpSmall: !1,
            enableHistoryState: y.data("enable-history-state") || !1,
            imageSize: null,
            namespace: ".slideshow-" + b,
            sectionId: b,
            sliderActive: !1,
            swatch_color: y.attr("data-product_swatch_color"),
            swatch_size: y.attr("data-product_swatch_size"),
            product_design: y.attr("data-product_design"),
            product_mobile_variant: y.attr("data-product_mobile_variant")
        }, this.selectors = {
            product: "#ProductSection-" + b,
            addToCart: "#AddToCart-" + b,
            addToCartText: "#AddToCartText-" + b,
            stockText: ".stock-" + b,
            comparePrice: "#ComparePrice-" + b,
            originalPrice: "#ProductPrice-" + b,
            SKU: ".variant-sku",
            originalPriceWrapper: ".product-price__price-" + b,
            originalSelectorId: "#ProductSelect-" + b,
            productFeaturedImage: ".FeaturedImage-" + b,
            productImageWrap: "#FeaturedImageZoom-" + b,
            productPrices: ".product-single__price-" + b,
            productThumbImages: "#product-thumbnails-" + b,
            productMainImages: "#product-images-" + b,
            productPreviewMainImages: ".product-preview-images-" + b,
            saleLabel: ".product-price__sale-label-" + b,
            singleOptionSelector: ".single-option-selector-" + b,
            singleOptionSelectorId: "#single-option-selector-" + b,
            singleOptionSwatches: "tawcvs-swatches-" + b,
            instagramProduct: "#product-instagram-" + b,
            instagramProductNameSpace: "product-instagram-" + b,
            variationsSelector: "#variations-" + b,
            variationSelector: ".variation-select-" + b,
            qtyVariant: ".qty-variant-" + b,
            threedId: ".threed-id-" + b,
            countDownId: ".countdown-" + b,
            couponCode: "#coupon-code-" + b,
            couponBtn: "#coupon-btn-" + b,
            sidebarSlide: ".sidebar-slick-vertical-" + b
        }, $("#ProductJson-" + b).html() && (this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + b).innerHTML), this._stringOverrides(), this._initCountDown(), this._initCoupon(), this._initPopup(), this._initVariants(), this._initSwatches(), this._initFeature(), this._initCompact(), this._initStickyImages(), this._initThumbnailsGallery(), this._initImages(), this._initSidebar(), this._initZoom(), this._initGallery(), this._initTab(), this._initQuantity(), this._initReviewTab(), this._relatedProducts(), this._instagramProducts())
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _stringOverrides: function () {
            theme.productStrings = theme.productStrings || {}, $.extend(theme.strings, theme.productStrings)
        },
        _initBreakpoints: function () {
            this;
            enquire.register(this.settings.mediaQuerySmall, {
                match: function () {},
                unmatch: function () {}
            }), enquire.register(this.settings.mediaQueryMediumUp, {
                match: function () {}
            })
        },
        _initPopup: function () {
            $(".sizechart-btn").magnificPopup({
                type: "image",
                midClick: !0
            }), $(".return-btn").click(function () {
                return $.magnificPopup.open({
                    items: {
                        src: "#delivery-return",
                        type: "inline"
                    },
                    tLoading: "",
                    mainClass: "popup-wrapper mfp-with-zoom",
                    removalDelay: 200
                }), !1
            })
        },
        _initCoupon: function () {
            0 < $(this.selectors.couponBtn).length && $(this.selectors.couponBtn).unbind("click") && $(this.selectors.couponBtn).click(function () {
                var v = $("<input>");
                $("body").append(v), v.val($(this).data("coupon")).select(), document.execCommand("copy"), v.remove(), jQuery("#rtp-message").html($(this).data("copied")), jQuery("#rt-unero-popup-message").css("margin-left", "-" + parseFloat(jQuery("#rt-unero-popup-message").width()) / 2 + "px").fadeIn(), window.setTimeout(function () {
                    jQuery("#rt-unero-popup-message").fadeOut()
                }, 2e3)
            })
        },
        _initCountDown: function () {
            if (!(0 >= $(this.selectors.countDownId).length) && $().countdown && 0 < $(this.selectors.countDownId).length && "" != $(this.selectors.countDownId).data("countdown")) {
                var v = new Date,
                    y = $(this.selectors.countDownId).data("countdown").split("-"),
                    y = new Date(y[2], parseInt(y[0]) - 1, y[1]);
                v < y && $(this.selectors.countDownId).countdown({
                    until: y,
                    layout: "<span class=\"countdown-day\">{dn}d</span><span class=\"countdown-hour\">{hn}h</span><span class=\"countdown-minute\">{mn}m</span><span class=\"countdown-second\">{sn}s</span>"
                })
            }
        },
        _initFeature: function () {
            if (0 < $(this.selectors.product + " .product-video-button a").length && $(this.selectors.product + " .product-video-button a").magnificPopup({
                    type: "iframe",
                    mainClass: "mfp-fade",
                    removalDelay: 160,
                    preloader: !1,
                    disableOn: !1,
                    fixedContentPos: !1
                }), 0 < $(this.selectors.product + " .product-360-button a").length) {
                for (var C, v = [], y = JSON.parse(document.getElementById("threed-id-" + this.sectionId).innerHTML), b = 1; 72 >= b; b++) C = "f" + b, y[C] && v.push(y[C]);
                if (0 < v.length) {
                    var k = v.length;
                    $(this.selectors.threedId).ThreeSixty({
                        totalFrames: k,
                        endFrame: k,
                        currentFrame: 1,
                        imgList: ".threed-view-images",
                        progress: ".spinner",
                        imgArray: v,
                        height: null,
                        width: null,
                        responsive: !0,
                        navigation: !0,
                        onReady: function () {
                            $(".product-360-button a").magnificPopup({
                                type: "inline",
                                mainClass: "mfp-fade",
                                removalDelay: 160,
                                disableOn: !1,
                                preloader: !1,
                                fixedContentPos: !1,
                                callbacks: {
                                    open: function () {
                                        $(window).resize()
                                    }
                                }
                            })
                        }
                    })
                }
            }
        },
        _initCompact: function () {
            if (0 < $(".product-accordion").length) {
                var v = $(".product-accordion"),
                    y = $(".accordion-item");
                y.each(function () {
                    var b = $(this),
                        C = b.find(".title"),
                        k = C.innerHeight(),
                        S = b.find(".content").outerHeight(),
                        I = C.parent(".accordion-item");
                    C.data("height", k), b.data("height", k + S)
                }), y.each(function () {
                    var b = $(this),
                        C = b.find(".title"),
                        k = C.innerHeight(),
                        S = b.find(".content").outerHeight(),
                        I = C.parent(".accordion-item");
                    C.data("height", k), b.data("height", k + S), I.hasClass("active") && I.height(I.data("height"))
                }), v.on("click", ".accordion-item > .title", function () {
                    var b = $(this),
                        C = b.parent(".accordion-item");
                    C.hasClass("active") || y.closest(".active").removeClass("active").height(b.data("height")), C.toggleClass("active"), C.hasClass("active") ? C.height(C.data("height")) : C.height(b.data("height"))
                })
            }
        },
        _initStickyImages: function () {
            function v() {
                P = $(window).height(), T.each(function () {
                    x = $(this).offset().top, U > x - P + 20 && $(this).addClass("animate-images")
                })
            }

            function y() {
                U = $(window).scrollTop(), V = U + B + D, S = C.width(), q = C.offset().left + 15, O = I.offset().top, M = O + N, S > A && (z = (S - A) / 2, q += z), U + B >= O ? (C.addClass("block-sticked"), k.css({
                    top: B,
                    left: q,
                    width: S,
                    position: "fixed",
                    transform: "translateY(-20px)"
                })) : (C.removeClass("block-sticked"), k.css({
                    top: "auto",
                    left: "auto",
                    width: "auto",
                    position: "relative",
                    transform: "translateY(0px)"
                })), V > M + 50 ? C.addClass("hide-temporary") : C.removeClass("hide-temporary")
            }

            function b() {
                P = $(window).height(), D = C.outerHeight(), N = I.outerHeight(), D < P - B ? C.addClass("in-viewport").removeClass("not-in-viewport") : C.removeClass("in-viewport").addClass("not-in-viewport"), y(), v()
            }
            if ($("body").hasClass("unero-product-design-sticky")) {
                var x, z, C = $(".product-summary"),
                    k = C.find(".entry-summary"),
                    S = C.width(),
                    I = $(".unero-images"),
                    T = I.find(".shopify-product-gallery__wrapper a"),
                    P = $(window).height(),
                    N = I.outerHeight(),
                    B = 130,
                    A = 600,
                    D = C.outerHeight(),
                    U = $(window).scrollTop(),
                    O = I.offset().top,
                    q = C.offset().left + 15,
                    M = O + N,
                    V = U + B + D;
                C.css({
                    height: D
                }), $(window).resize(function () {
                    b()
                }), $(window).scroll(function () {
                    y(), v()
                }), I.imagesLoaded(function () {
                    b()
                })
            }
        },
        _initThumbnailsGallery: function () {
            var v = $(this.selectors.productMainImages);
            "gallery" == this.settings.product_design && $(".thumbnail-gallery-item").on("click", function () {
                var y = $(this);
                y.hasClass("active") || ($(".thumbnail-gallery-item").removeClass("active"), y.addClass("active"), $(".thumbnail-gallery-item").each(function (b) {
                    if ($(this).attr("id") == y.attr("id")) return void v.slick("slickGoTo", b, !0)
                }))
            })
        },
        _instagramProducts: function () {
            if (0 < $(this.selectors.instagramProduct).length) {
                var v = $(this.selectors.instagramProduct),
                    y = this.selectors.instagramProductNameSpace,
                    b = v.attr("data-id"),
                    C = v.attr("data-token"),
                    k = v.attr("data-limit"),
                    S = v.data("per_view"),
                    I = v.data("auto"),
                    T = !1,
                    x = v.data("speed"),
                    P = new Instafeed({
                        get: "user",
                        target: y,
                        accessToken: C,
                        userId: parseInt(b),
                        limit: parseInt(k),
                        resolution: "low_resolution",
                        resolution2: "standard_resolution",
                        template: "<li class=\"product\"><a class=\"insta-item\" target=\"_blank\" href=\"{{link}}\"><img src=\"{{image}}\" alt=\"{{caption}}\" /><i class=\"social_instagram\"></i></a></li>",
                        after: function () {
                            0 < I ? (T = !0, I = !0) : I = !1, v.not(".slick-initialized").slick({
                                slidesToShow: S,
                                slidesToScroll: 1,
                                autoplaySpeed: x,
                                autoplay: I,
                                infinite: T,
                                dots: !1,
                                prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                                nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>",
                                responsive: [{
                                    breakpoint: 1200,
                                    settings: {
                                        slidesToShow: 4,
                                        slidesToScroll: 1
                                    }
                                }, {
                                    breakpoint: 767,
                                    settings: {
                                        slidesToShow: 3,
                                        slidesToScroll: 1
                                    }
                                }]
                            })
                        }
                    });
                P.run()
            }
        },
        _relatedProducts: function () {
            var v = $(this.selectors.product + " .related.products ul.products");
            0 < v.length && v.not(".slick-initialized").slick({
                slidesToShow: v.data("per_view"),
                slidesToScroll: v.data("per_view"),
                arrows: !1,
                lazyLoad: "ondemand",
                dots: !0,
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }]
            })
        },
        _initReviewTab: function () {
            $(".rt-unero-product-rating").unbind("click"), $(".rt-unero-product-rating").click(function () {
                0 < $("a[href=\"#tab-reviews\"]").length && $("a[href=\"#tab-reviews\"]").trigger("click"), $("html,body").animate({
                    scrollTop: $("#tab-reviews").offset().top
                }, "slow")
            })
        },
        _initQuantity: function () {
            var v = $(this.selectors.addToCart),
                y = $(this.selectors.qtyVariant);
            $(".q_up").unbind("click"), $(".q_up").click(function () {
                var b = $(this).data("product_id"),
                    C = parseInt($(".qty-" + b).val()) + 1;
                if ($(".qty-" + b).val(C), 0 < y.length) {
                    var k = !1;
                    y.each(function () {
                        var S = parseInt($(this).val()),
                            I = $(this).data("variant_id");
                        0 == S ? !$("form#cart-variant-form-" + I).hasClass("not-submit") && $("form.variant-form-" + b).addClass("not-submit") : (k = !0, $("form#cart-variant-form-" + I).removeClass("not-submit"))
                    }), k ? v.removeClass("disabled") : !v.hasClass("disabled") && v.addClass("disabled")
                }
            }), $(".q_down").unbind("click"), $(".q_down").click(function () {
                var b = $(this).data("product_id"),
                    C = parseInt($(".qty-" + b).val());
                if (0 < y.length) {
                    0 < C && $(".qty-" + b).val(C - 1);
                    var k = !1;
                    y.each(function () {
                        var S = parseInt($(this).val()),
                            I = $(this).data("variant_id");
                        0 == S ? !$("form#cart-variant-form-" + I).hasClass("not-submit") && $("form.variant-form-" + b).addClass("not-submit") : (k = !0, $("form#cart-variant-form-" + I).removeClass("not-submit"))
                    }), k ? v.removeClass("disabled") : !v.hasClass("disabled") && v.addClass("disabled")
                } else 1 < C && $(".qty-" + b).val(C - 1)
            })
        },
        _initTab: function () {
            $(this.selectors.product + " .product-tabs").off("click").on("click", "ul.tabs li a", function (v) {
                if (v.preventDefault(), $(this).parent("li").hasClass("active")) return !1;
                var y = $(this),
                    b = y.closest(".product-tabs"),
                    C = b.find("ul.tabs");
                return C.find("li").removeClass("active"), $(this).parent("li").addClass("active"), b.find(".panel:visible").fadeOut(300, function () {
                    b.find(y.attr("href")).fadeIn(300)
                }), !1
            })
        },
        _initGallery: function () {
            (function (y) {
                function b(A, z) {
                    return -1 < (" " + A.className + " ").indexOf(" " + z + " ")
                }
                for (var C = function (A) {
                        for (var O, q, M, V, z = $(A).find(".photoswipe-item").get(), D = z.length, U = [], L = 0; L < D; L++)
                            if (O = z[L], 1 === O.nodeType)
                                if (q = O.children[0], M = q.getAttribute("data-size").split("x"), "video" == $(q).data("type")) {
                                    var E = $($(q).data("id")).html();
                                    U.push({
                                        html: E
                                    })
                                } else V = {
                                    src: q.getAttribute("href"),
                                    w: parseInt(M[0], 10),
                                    h: parseInt(M[1], 10)
                                }, 1 < O.children.length && (V.title = $(O).find(".caption").html()), 0 < q.children.length && (V.msrc = q.children[0].getAttribute("src")), V.el = O, U.push(V);
                        return U
                    }, k = function A(z, D) {
                        return z && (D(z) ? z : A(z.parentNode, D))
                    }, S = function (A) {
                        A = A || window.event, A.preventDefault ? A.preventDefault() : A.returnValue = !1;
                        var z = A.target || A.srcElement,
                            D = k(z, function (E) {
                                return b(E, "photoswipe-item")
                            });
                        if (D) {
                            for (var V, U = D.closest(".photoswipe-wrapper"), O = $(D.closest(".photoswipe-wrapper")).find(".photoswipe-item").get(), q = O.length, M = 0, L = 0; L < q; L++)
                                if (1 === O[L].nodeType) {
                                    if (O[L] === D) {
                                        V = M;
                                        break
                                    }
                                    M++
                                } return 0 <= V && T(V, U), !1
                        }
                    }, I = function () {
                        var A = window.location.hash.substring(1),
                            z = {};
                        if (5 > A.length) return z;
                        for (var D = A.split("&"), U = 0; U < D.length; U++)
                            if (D[U]) {
                                var O = D[U].split("=");
                                2 > O.length || (z[O[0]] = O[1])
                            } return z.gid && (z.gid = parseInt(z.gid, 10)), z
                    }, T = function (A, z, D, U) {
                        var q, M, V, O = document.querySelectorAll(".pswp")[0];
                        if (V = C(z), M = {
                                closeOnScroll: !1,
                                galleryUID: z.getAttribute("data-pswp-uid")
                            }, !U) M.index = parseInt(A, 10);
                        else if (M.galleryPIDs) {
                            for (var L = 0; L < V.length; L++)
                                if (V[L].pid == A) {
                                    M.index = L;
                                    break
                                }
                        } else M.index = parseInt(A, 10) - 1;
                        isNaN(M.index) || (D && (M.showAnimationDuration = 0), q = new PhotoSwipe(O, PhotoSwipeUI_Default, V, M), q.init(), q.listen("beforeChange", function () {
                            var E = $(q.currItem.container);
                            $(".pswp__video").removeClass("active");
                            E.find(".pswp__video").addClass("active");
                            $(".pswp__video").each(function () {
                                $(this).hasClass("active") || $(this).attr("src", $(this).attr("src"))
                            })
                        }), q.listen("close", function () {
                            $(".pswp__video").each(function () {
                                $(this).attr("src", $(this).attr("src"))
                            })
                        }))
                    }, x = document.querySelectorAll(y), P = 0, N = x.length; P < N; P++) x[P].setAttribute("data-pswp-uid", P + 1), x[P].onclick = S;
                var B = I();
                B.pid && B.gid && T(B.pid, x[B.gid - 1], !0, !0)
            })(this.selectors.product + " .photoswipe-wrapper")
        },
        _initZoom: function () {
            if ($(".easyzoom").length)
                if (1024 < $(window).width()) var v = $(".easyzoom:not(.feature-video)").easyZoom({
                        loadingNotice: "",
                        errorNotice: "",
                        preventClicks: !1
                    }),
                    y = v.data("easyZoom");
                else $(".easyzoom a").click(function (b) {
                    b.preventDefault()
                })
        },
        _initImages: function () {
            var v = this,
                y = $(v.selectors.productMainImages);
            if ("left" != this.settings.product_design && "bottom" != this.settings.product_design && "sidebar" != this.settings.product_design && "full-screen" != this.settings.product_design) "carousel" == this.settings.product_design ? y.not(".slick-initialized").slick({
                centerMode: !0,
                centerPadding: "500px",
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>",
                responsive: [{
                    breakpoint: 1680,
                    settings: {
                        centerMode: !0,
                        centerPadding: "400px",
                        slidesToShow: 1
                    }
                }, {
                    breakpoint: 1440,
                    settings: {
                        centerMode: !0,
                        centerPadding: "350px",
                        slidesToShow: 1
                    }
                }, {
                    breakpoint: 1200,
                    settings: {
                        centerMode: !0,
                        centerPadding: "300px",
                        slidesToShow: 1
                    }
                }, {
                    breakpoint: 1024,
                    settings: {
                        arrows: !1,
                        centerMode: !0,
                        centerPadding: "250px",
                        slidesToShow: 1
                    }
                }, {
                    breakpoint: 992,
                    settings: {
                        centerMode: !0,
                        centerPadding: "200px",
                        slidesToShow: 1
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        arrows: !1,
                        centerMode: !0,
                        centerPadding: "125px",
                        slidesToShow: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        arrows: !1,
                        centerMode: !0,
                        centerPadding: "50px",
                        slidesToShow: 1
                    }
                }]
            }) : y.not(".slick-initialized").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: !1,
                asNavFor: b,
                prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>"
            });
            else if (0 < $(v.selectors.productThumbImages).length) {
                var b = $(v.selectors.productThumbImages).find(".thumbnails");
                y.not(".slick-initialized").slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: !1,
                    asNavFor: b,
                    prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                    nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>"
                });
                var C = "0" != $(v.selectors.productThumbImages).data("vertical");
                b.not(".slick-initialized").slick({
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    asNavFor: y,
                    focusOnSelect: !0,
                    vertical: C,
                    infinite: !1,
                    prevArrow: "<span class=\"icon-chevron-up slick-prev-arrow\"></span>",
                    nextArrow: "<span class=\"icon-chevron-down slick-next-arrow\"></span>"
                })
            }
            y.imagesLoaded(function () {
                y.addClass("loaded")
            })
        },
        _initSidebar: function () {
            var v = this;
            $sidebarSlide = $(v.selectors.sidebarSlide), 0 < $sidebarSlide.length && $sidebarSlide.each(function () {
                var y = $(this),
                    b = $(this).data("per_view");
                $(this).not(".slick-initialized").slick({
                    slidesToShow: b,
                    slidesToScroll: 1,
                    vertical: !0,
                    focusOnSelect: !0,
                    infinite: !1,
                    prevArrow: "<span class=\"icon-chevron-up slick-prev-arrow\"></span>",
                    nextArrow: "<span class=\"icon-chevron-down slick-next-arrow\"></span>"
                }), y.imagesLoaded(function () {
                    y.addClass("loaded")
                })
            })
        },
        _initForceHeight: function () {
            0 < $(this.selectors.productPreviewMainImages).length && $(this.selectors.productPreviewMainImages).not(".slick-initialized").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: !1,
                prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>"
            })
        },
        _initSwatches: function () {
            var v = this.productSingleObject,
                y = [];
            if ("1" == this.settings.swatch_size && y.push("Size"), y.push("size"), "1" == this.settings.swatch_color && (y.push("Color"), y.push("Colour"), y.push("color"), y.push("colour")), 0 < y.length) {
                var b = !1,
                    C = !1,
                    k = 0,
                    S = theme.asset_url.substring(0, theme.asset_url.lastIndexOf("?")),
                    I = theme.asset_url.substring(theme.asset_url.lastIndexOf("?"), theme.asset_url.length);
                for (i = 0; i < v.options.length; i++) {
                    var T = "",
                        x = "",
                        P = "",
                        N = "",
                        B = "",
                        A = "",
                        z = "";
                    if (T = "object" == typeof v.options[i] ? v.options[i].name : v.options[i], b = !1, C = !1, -1 < y.indexOf(T)) {
                        b = !0, k = i;
                        var D = T.toLowerCase();
                        if (/color|colour/i.test(D) && (C = !0), b) {
                            var O = [];
                            for (j = 0; j < v.variants.length; j++) {
                                var q = v.variants[j],
                                    M = this.htmlEntities(q.options[k]),
                                    V = this.convertToSlug(M);
                                0 > O.indexOf(M) && (z = "color" != D && "colour" != D ? "swatch-label " : "", A = $(this.selectors.singleOptionSelectorId + "-" + k).val() == M ? "selected " : "", P = P + "<span data-id=\"" + this.selectors.singleOptionSelectorId + "-" + k + "\" data-original-title=\"" + M + "\" class=\"" + A + "swatch " + z + " swatch-" + D + " swatch-" + M + "\" title=\"" + M + "\" data-value=\"" + M + "\" style=\"background-color:" + M + "; background-image: url(" + S + V + ".png" + I + ")\">" + M + "<span class='unero-tooltip '><span class='unero-tooltip-label'>" + M + "</span></span></span>", O.push(M))
                            }
                            x = "<div class=\"" + this.selectors.singleOptionSwatches + " tawcvs-swatches\" data-attribute_name=\"attribute_pa_" + D + "\">" + P + "</div>", N = $(this.selectors.singleOptionSelectorId + "-" + k), B = $(this.selectors.variationSelector + "-" + k), "" != x && (N.after(x), N.hide(), B.addClass("hide-choose-option"))
                        }
                    }
                }
            }
            var E = "";
            0 < $("." + this.selectors.singleOptionSwatches).length && (E = $("." + this.selectors.singleOptionSwatches + " > span"), E.unbind("click"), E.on("click", function () {
                var H = $(this).data("id");
                $(this).data("value") != $(H).val() && ($(H).val($(this).data("value")).trigger("change"), $(H).closest("td").find("span.swatch").removeClass("selected"), $(this).addClass("selected"))
            }))
        },
        htmlEntities: function (v) {
            return (v + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")
        },
        convertToSlug: function (v) {
            return v.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
        },
        _initVariants: function () {
            var v = {
                $container: this.$container,
                enableHistoryState: this.$container.data("enable-history-state") || !1,
                singleOptionSelector: this.selectors.singleOptionSelector,
                originalSelectorId: this.selectors.originalSelectorId,
                product: this.productSingleObject
            };
            this.variants = new slate.Variants(v), this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCart.bind(this)), this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this)), this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)), this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this))
        },
        _updateAddToCart: function (v) {
            var y = v.variant;
            y ? ($(this.selectors.productPrices).removeClass("invisible").attr("aria-hidden", "true"), y.available ? ($(".variations_button").removeClass("hide"), $(this.selectors.addToCart).prop("disabled", !1).toggleClass("hide", !1), $(this.selectors.addToCartText).text(theme.strings.addToCart), $(this.selectors.stockText).html(theme.strings.available + "<span>" + theme.strings.inStock + "</span>").removeClass("out-of-stock").addClass("in-stock"), "shopify" == y.inventory_management && "continue" != y.inventory_policy && (0 < y.inventory_quantity && 1 == parseInt(theme.inventory) ? $(this.selectors.stockText).html(theme.strings.available + "<span>" + y.inventory_quantity + " " + theme.strings.inStock + "</span>") : $(this.selectors.stockText).html(theme.strings.available + "<span>" + theme.strings.inStock + "</span>"))) : ($(".variations_button").addClass("hide"), $(this.selectors.addToCart).prop("disabled", !0).toggleClass("hide", !0), $(this.selectors.addToCartText).text(theme.strings.soldOut), $(this.selectors.stockText).html(theme.strings.available + "<span>" + theme.strings.outStock + "</span>").removeClass("in-stock").addClass("out-of-stock"))) : ($(".variations_button").addClass("hide"), $(this.selectors.addToCart).prop("disabled", !0).toggleClass("hide", !0), $(this.selectors.addToCartText).text(theme.strings.unavailable), $(this.selectors.stockText).html("<span>" + theme.strings.unavailable + "</span>").removeClass("in-stock").addClass("out-of-stock"), $(this.selectors.productPrices).addClass("invisible").attr("aria-hidden", "false"))
        },
        _updateImages: function (v) {
            var y = v.variant,
                b = this,
                C = this.settings.product_design,
                k = y.featured_image.src.replace("https:", "").replace("http:", "").split("?v=")[0];
            $(this.selectors.productFeaturedImage).each(function () {
                var I = $(this),
                    T = I.attr("href");
                if (0 <= T.indexOf(k) && !I.closest(".slick-slide").hasClass("slick-cloned")) {
                    var x = $(b.selectors.productMainImages),
                        P = I.closest(".slick-slide").attr("data-slick-index");
                    if ("carousel" == C ? x.slick("slickGoTo", P) : x.slick("slickGoTo", P, !0), "scroll" == C) {
                        var N = parseInt(I.closest(".shopify-product-gallery__image").offset().top) - 50;
                        $("html,body").animate({
                            scrollTop: N
                        }, "slow")
                    }
                    return void("gallery" == C && 0 < $(".thumbnails .thumbnail-gallery-item").length && $(".thumbnails .thumbnail-gallery-item").each(function () {
                        var B = $(this).data("href");
                        0 <= B.indexOf(k) && $(this).trigger("click")
                    }))
                }
            })
        },
        _updatePrice: function (v) {
            var y = v.variant;
          console.log(y.price);
            if ($(this.selectors.originalPrice).html("<span class=\"money\">" + theme.Currency.formatMoney(y.price, theme.moneyFormat) + "</span>"), y.compare_at_price > y.price) {
                if ($(this.selectors.productPrices).addClass("has-sale"), $(this.selectors.productPrices).removeClass("not-sale"), $(this.selectors.comparePrice).html("<span class=\"money\">" + theme.Currency.formatMoney(y.compare_at_price, theme.moneyFormat) + "</span>").removeClass("hide"), $(this.selectors.saleLabel).find("span").text(theme.strings.sale), "" != theme.sale_percentages) {
                    var b = Math.round(100 * (y.compare_at_price - y.price) / y.compare_at_price);
                    $(this.selectors.saleLabel).find("span").text("-" + b + "%")
                }
                $(this.selectors.saleLabel).addClass("hide")
            } else $(this.selectors.productPrices).removeClass("has-sale"), $(this.selectors.productPrices).addClass("not-sale"), $(this.selectors.comparePrice).addClass("hide"), $(this.selectors.saleLabel).addClass("hide");
            theme.CurrencyPicker.convert(this.selectors.product + " .money")
        },
        _updateSKU: function (v) {
            var y = v.variant;
            "" == y.sku ? $(this.selectors.SKU).addClass("hide") : $(this.selectors.SKU).removeClass("hide").find(".sku").text(y.sku)
        },
        onUnload: function () {
            this.$container.off(this.settings.namespace)
        }
    }), p
}(), theme.Cart = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.cartId = $("#shopify-section-" + b), this.cart = $("#cart-" + b), this.cartNamespace = "#cart-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            Shopify.Cart.ShippingCalculator.show({
                submitButton: theme.strings.shippingCalcSubmitButton,
                submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
                customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
                moneyFormat: theme.strings.shippingCalcMoneyFormat
            }), this._initQuantity()
        },
        _initQuantity: function () {
            $(".q_up").unbind("click"), $(".q_up").click(function () {
                var v = $(this).data("product_id"),
                    y = parseInt($(".qty-" + v).val()) + 1;
                $(".qty-" + v).val(y)
            }), $(".q_down").unbind("click"), $(".q_down").click(function () {
                var v = $(this).data("product_id"),
                    y = parseInt($(".qty-" + v).val());
                1 < y && $(".qty-" + v).val(y - 1)
            })
        },
        onUnload: function () {
            this.$container.off(this.cartNamespace)
        }
    }), p
}(), theme.SearchTemplate = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.SearchId = $("#search-" + b), this.Search = $("#search-" + b), this.SearchNamspace = "#search-" + b, this.collection_infinite_scoll = this.Search.data("collection_infinite_scoll"), this.collection_infinite_scoll_auto = this.Search.data("collection_infinite_scoll_auto"), this.pInfScrLoading = !1, this.pInfScrMore = !0, this.flagScroll = !0, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            this._initCollectionControl()
        },
        _initCollectionControl: function () {
            var v = this;
            "1" == this.collection_infinite_scoll && ("1" == this.collection_infinite_scoll_auto && $(window).scroll(function () {
                var y = $(".load_more");
                if (0 < y.length) {
                    var b = $(window),
                        C = b.scrollTop(),
                        k = C + b.height(),
                        S = y.offset().top,
                        I = S + y.height();
                    I <= k && S >= C && v.flagScroll && (v.flagScroll = !1, y.find("a").trigger("click"))
                }
            }), jQuery(".load_more a").click(function (y) {
                return v._pInfScrExecute(), y.stopPropagation(), !1
            }))
        },
        _pInfScrExecute: function () {
            var v = this,
                y = $(".load_more").last(),
                b = $(".load_more a").last().attr("href");
            0 < y.length && v.pInfScrMore && $.ajax({
                type: "GET",
                url: b,
                beforeSend: function () {
                    jQuery(".load_more").hide(), jQuery("#un-products-loading").toggleClass("hide").fadeIn()
                },
                success: function (C) {
                    var k = jQuery(C).find(".products .product");
                    if (jQuery(".products").append(k), jQuery("#un-products-loading").toggleClass("hide").fadeOut(), $(document.body).find("img.lazy").lazyload(), jQuery(C).find(".load_more a").length) {
                        jQuery(".load_more a").last().attr("href", jQuery(C).find(".load_more a").last().attr("href")), jQuery(".load_more").show(), v.flagScroll = !0;
                        var S = parseInt(jQuery(C).find(".load_more a").last().data("page"));
                        if (0 < S) {
                            var I = parseInt($(".page-num-offset").data("page_size")),
                                T = parseInt($(".page-num-offset").data("total_result")),
                                x = S * I;
                            T > x && $(".result-offset").html(x).css("padding-right", "5px")
                        } else $(".page-num-offset").html($(".page-num-offset").data("total_result"))
                    } else v.pInfScrMore = !1, jQuery(".load_more").remove(), $(".page-num-offset").html($(".page-num-offset").data("total_result"));
                    v._initReviews(), v._initCountDown(), $("[data-toggle=\"tooltip\"]").tooltip(), theme.CurrencyPicker.convert(".un-shop-content .money")
                },
                dataType: "html"
            })
        },
        _initCountDown: function () {
            $().countdown && 0 < $(".countdown-item").length && $(".countdown-item").each(function () {
                if ("" != $(this).data("countdown")) {
                    var v = new Date,
                        y = $(this).data("countdown").split("-"),
                        y = new Date(y[2], parseInt(y[0]) - 1, y[1]);
                    v < y && $(this).countdown({
                        until: y,
                        layout: "<span class=\"countdown-day\">{dn}d</span><span class=\"countdown-hour\">{hn}h</span><span class=\"countdown-minute\">{mn}m</span><span class=\"countdown-second\">{sn}s</span>"
                    })
                }
            })
        },
        _initReviews: function () {
            "undefined" != typeof SPR && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges())
        },
        onUnload: function () {
            this.$container.off(this.SearchNamspace)
        }
    }), p
}(), theme.footerSection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.footerId = $("#shopify-section-" + b), this.footer = $("#site-" + b), this.footerNamespace = "#site-" + b, this.footerNewsletterForm = $("#mc-form-" + b), this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            this._initFooter(), 0 < this.footerNewsletterForm.length && this._initMailChimp()
        },
        _initFooter: function () {
            var v = $("#site-footer").data("parallax");
            "1" == v ? ($(document.body).removeClass("footer-no-parallax").addClass("footer-parallax"), $(window).on("resize", function () {
                var y = $("#site-footer .footer-layout").outerHeight(!0);
                if ($(document.body).css("padding-bottom", y), $(document.body).hasClass("page-header-layout-3") && "1" == $(".page-header").data("parallax")) {
                    $("#site-footer").addClass("has-parallax");
                    var b = $(".page-header").height();
                    $(window).on("scroll", function () {
                        $(window).scrollTop() > b ? $("#site-footer").addClass("active") : $("#site-footer").removeClass("active")
                    })
                }
            }).trigger("resize")) : $(document.body).removeClass("footer-parallax").addClass("footer-no-parallax")
        },
        _initMailChimp: function () {
            var v = this.footerNewsletterForm,
                y = v.attr("action");
            v.ajaxChimp({
                url: y,
                callback: function (b) {
                    "success" == b.result ? (jQuery("#rtp-message").html(b.msg), jQuery("#rt-unero-popup-message").css("margin-left", "-" + parseFloat(jQuery("#rt-unero-popup-message").width()) / 2 + "px").fadeIn(), window.setTimeout(function () {
                        jQuery("#rt-unero-popup-message").fadeOut()
                    }, 2e3), v.find(".mc4wp-response").removeClass("error").hide()) : v.find(".mc4wp-response").addClass("error").html(b.msg).show()
                }
            })
        },
        onUnload: function () {
            this.$container.off(this.footerNamespace)
        }
    }), p
}(), theme.sideBarSection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.sidebarId = $("#shopify-section-" + b), this.sidebar = $("#menu-sidebar-" + b), this.sidebarNamespace = "#menu-sidebar-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            this._initMenu()
        },
        _initMenu: function () {
            $(".sidebar-child-menu").unbind("click"), $(".sidebar-child-menu").click(function (v) {
                v.preventDefault(), $(this).closest("li").siblings().find("ul").slideUp(), $(this).closest("li").siblings().removeClass("active"), $(this).closest("li").siblings().find("li").removeClass("active"), $(this).closest("li").children("ul").slideToggle(), $(this).closest("li").toggleClass("active"), $(this).toggleClass("active")
            })
        },
        onUnload: function () {
            this.$container.off(this.sidebarNamespace)
        }
    }), p
}(), theme.mobileNavSection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.mobileNavId = $("#shopify-section-" + b), this.mobileNav = $("#primary-" + b), this.mobilenavNamespace = "#primary-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            this._initMobile()
        },
        _initMobile: function () {
            function v() {
                $(document.body).removeClass("open-canvas-panel"), $(".unero-off-canvas-panel, #primary-mobile-nav").removeClass("open")
            }
            var y = this.mobileNav;
            $("#header-header").on("click", "#un-navbar-toggle", function (b) {
                b.preventDefault(), y.toggleClass("open"), $(document.body).toggleClass("open-canvas-panel")
            }), y.on("click", ".mobile-child-menu", function (b) {
                b.preventDefault(), $(this).closest("li").siblings().find("ul").slideUp(), $(this).closest("li").siblings().removeClass("active"), $(this).closest("li").siblings().find("li").removeClass("active"), $(this).closest("li").children("ul").slideToggle(), $(this).closest("li").toggleClass("active")
            }), 0 < $(".mobile-nav-footer").length && $(".mobile-nav-footer").on("click", ".toggle-children", function (b) {
                b.preventDefault(), $(this).closest("li").siblings().find("ul").slideUp(), $(this).closest("li").siblings().removeClass("active"), $(this).closest("li").siblings().find("li").removeClass("active"), $(this).closest("li").children("ul").slideToggle(), $(this).closest("li").toggleClass("active")
            }), y.on("click", ".close-canvas-mobile-panel", function (b) {
                b.preventDefault(), v()
            }), $(window).on("resize", function () {
                991 < $(window).width() && y.hasClass("open") && (y.removeClass("open"), $(document.body).removeClass("open-canvas-panel"))
            })
        },
        onUnload: function () {
            this.$container.off(this.mobilenavNamespace)
        }
    }), p
}(), theme.CollectionTemplate = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.CollectionId = $("#collection-" + b), this.Collection = $("#collection-" + b), this.CollectionNamspace = "#collection-" + b, this.collection_infinite_scoll = this.Collection.data("collection_infinite_scoll"), this.collection_infinite_scoll_auto = this.Collection.data("collection_infinite_scoll_auto"), this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            this._initCollectionFilter()
        },
        _initCollectionFilter: function () {
            function v() {
                var T = $(".load_more").last(),
                    x = $(".load_more a").last().attr("href");
                0 < T.length && S && $.ajax({
                    type: "GET",
                    url: x,
                    beforeSend: function () {
                        jQuery(".load_more").hide(), jQuery("#un-products-loading").toggleClass("hide").fadeIn()
                    },
                    success: function (P) {
                        var N = jQuery(".products"),
                            B = jQuery(P).find(".products .product");
                        if ($(document.body).hasClass("catalog-board-content") || $(document.body).hasClass("collection-metro-content") ? B.imagesLoaded(function () {
                                N.isotope("insert", B), theme.roarApplication.initLoadMore()
                            }) : (N.append(B), theme.roarApplication.initLoadMore()), jQuery("#un-products-loading").toggleClass("hide").fadeOut(), $(document.body).find("img.lazy").lazyload(), jQuery(P).find(".load_more a").length) {
                            jQuery(".load_more a").last().attr("href", jQuery(P).find(".load_more a").last().attr("href")), jQuery(".load_more").show(), I = !0;
                            var A = parseInt(jQuery(P).find(".load_more a").last().data("page"));
                            if (0 < A) {
                                var z = parseInt($(".page-num-offset").data("page_size")),
                                    D = parseInt($(".page-num-offset").data("total_result")),
                                    U = A * z;
                                D > U && $(".result-offset").html(U).css("padding-right", "5px")
                            } else $(".page-num-offset").html($(".page-num-offset").data("total_result"))
                        } else S = !1, jQuery(".load_more").remove(), $(".page-num-offset").html($(".page-num-offset").data("total_result"));
                        theme.CurrencyPicker.convert(".un-shop-content .money")
                    },
                    dataType: "html"
                })
            }

            function y(T) {
                delete Shopify.queryParams.page;
                var x = b(T);
                C(x)
            }

            function b(T) {
                var x = $.param(Shopify.queryParams).replace(/%2B/g, "+");
                return T ? "" == x ? T : T + "?" + x : location.pathname + "?" + x
            }

            function C(T) {
                var x = $("#un-shop-content"),
                    P = $("#primary-sidebar"),
                    N = $("#primary-offcanvas"),
                    B = $("#un-categories-filter"),
                    A = $("#un-shop-topbar"),
                    z = $(".product-found > span"),
                    D = $(".shop-toolbar .rt-unero-ordering");
                if (0 < $("#un-shop-toolbar").length) {
                    var U = $("#un-shop-toolbar").offset().top - 200;
                    $("html, body").stop().animate({
                        scrollTop: U
                    }, 1200)
                }
                $("#un-shop-loading").addClass("show"), $.ajax({
                    type: "get",
                    url: T,
                    beforeSend: function () {
                        ($("#un-shop-toolbar").hasClass("on-mobile") || $("#un-shop-topbar").hasClass("on-mobile")) && ($("#un-categories-filter").slideUp(), $("#un-shop-topbar").slideUp(), $("#un-toggle-cats-filter").removeClass("active"), $(".un-filter").removeClass("active"))
                    },
                    success: function (O) {
                        x.replaceWith($(O).find("#un-shop-content")), P.html($(O).find(".catalog-sidebar").html()), N.html($(O).find(".catalog-offcanvas").html()), B.html($(O).find("#un-categories-filter").html()), A.html($(O).find("#un-shop-topbar").html()), z.html($(O).find(".product-found > span").html()), D.html($(O).find(".shop-toolbar .rt-unero-ordering").html()), "?" == T.slice(-1) && (T = T.slice(0, -1)), T = T.replace(/%2C/g, ","), history.pushState(null, null, T), theme.roarApplication.initLoadMore(), S = !0, I = !0, theme.CurrencyPicker.convert(".un-shop-content .money"), $("#un-shop-loading").removeClass("show"), 0 < $(".wc-layered-nav-term.chosen").length ? $("#remove-filter-actived").removeClass("hide") : $("#remove-filter-actived").addClass("hide")
                    },
                    error: function () {
                        $("#un-shop-loading").removeClass("show")
                    }
                })
            }
            if (0 < $(".shop-bottombar").length && $(window).on("scroll", function () {
                    $(document.body).find("#un-shop-footer").is(":in-viewport") ? $(".shop-bottombar").find(".un-filter").addClass("not-viewport") : $(".shop-bottombar").find(".un-filter").removeClass("not-viewport")
                }).trigger("scroll"), $("body").on("click", ".wc-layered-nav-term a", function (T) {
                    var T = $(this).parent(),
                        x = $(this).data("value"),
                        P = [];
                    if (Shopify.queryParams.constraint && (P = Shopify.queryParams.constraint.split("+")), !window.enable_filter_multiple_choice && !T.hasClass("chosen")) {
                        var N = T.parents(".wc-layered-nav-term").find(".chosen");
                        0 < N.length && N.each(function () {
                            var A = $(this).data("handle");
                            if ($(this).removeClass("chosen"), A) {
                                var z = P.indexOf(A);
                                0 <= z && P.splice(z, 1)
                            }
                        })
                    }
                    if (x) {
                        var B = P.indexOf(x);
                        0 > B ? (P.push(x), T.addClass("chosen")) : (P.splice(B, 1), T.removeClass("chosen"))
                    }
                    P.length ? Shopify.queryParams.constraint = P.join("+") : delete Shopify.queryParams.constraint, y()
                }), $("body").on("click", ".rt-unero-pagination a", function (T) {
                    var x = $(this);
                    delete Shopify.queryParams.page, delete Shopify.queryParams.constraint, delete Shopify.queryParams.q, delete Shopify.queryParams.sort_by, y(x.attr("href")), T.preventDefault()
                }), $("body").on("click", ".rt-unero-ordering a", function (T) {
                    var x = $(this),
                        P = x.data("sort");
                    $(".rt-unero-ordering a").removeClass("active"), x.addClass("active"), Shopify.queryParams.sort_by = P, y(), T.preventDefault()
                }), $("body").on("click", "#unero_product_tag_cloud a", function (T) {
                    var T = $(this),
                        x = $(this).data("value"),
                        P = [];
                    if (Shopify.queryParams.constraint && (P = Shopify.queryParams.constraint.split("+")), !window.enable_filter_multiple_choice && !T.hasClass("selected")) {
                        var N = T.parents(".tagcloud").find(".selected");
                        0 < N.length && N.each(function () {
                            var A = $(this).data("handle");
                            if ($(this).removeClass("selected"), A) {
                                var z = P.indexOf(A);
                                0 <= z && P.splice(z, 1)
                            }
                        })
                    }
                    if (x) {
                        var B = P.indexOf(x);
                        0 > B ? (P.push(x), T.addClass("selected")) : (P.splice(B, 1), T.removeClass("selected"))
                    }
                    P.length ? Shopify.queryParams.constraint = P.join("+") : delete Shopify.queryParams.constraint, y()
                }), "1" == this.collection_infinite_scoll) {
                var S = !0,
                    I = !0;
                "1" == this.collection_infinite_scoll_auto && $(window).scroll(function () {
                    var T = $(".load_more");
                    if (0 < T.length) {
                        var x = $(window),
                            P = x.scrollTop(),
                            N = P + x.height(),
                            B = T.offset().top,
                            A = B + T.height();
                        A <= N && B >= P && I && (I = !1, T.find("a").trigger("click"))
                    }
                }), $("body").on("click", ".load_more a", function (T) {
                    return v(), T.stopPropagation(), !1
                })
            }
            $("body").on("click", "#remove-filter-actived", function (T) {
                delete Shopify.queryParams.page, delete Shopify.queryParams.constraint, delete Shopify.queryParams.q, y(), T.preventDefault()
            })
        },
        _initReviews: function () {
            "undefined" != typeof SPR && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges())
        },
        onUnload: function () {
            this.$container.off(this.SearchNamspace)
        }
    }), p
}(), theme.CollectionInstagramTemplate = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.collectionId = $("#shopify-section-" + b), this.collection = $("#collection-" + b), this.collectionNamespace = "#collection-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            this._initInstafeed()
        },
        _initInstafeed: function () {
            var v = "shop-instagram-" + this.sectionId,
                y = this.collection.data("token"),
                b = this.collection.data("id"),
                C = this.collection.data("limit"),
                k = new Instafeed({
                    get: "user",
                    target: v,
                    accessToken: y,
                    userId: b,
                    limit: C,
                    resolution: "standard_resolution",
                    resolution2: "standard_resolution",
                    template: "<div class=\"wrap animated\"><a class=\"fauximg-bin\" target=\"_blank\" href=\"{{link}}\"><figure class=\"snpt__fauximg\" style=\"background-image: url({{image}})\"></figure><i class=\"t-icon icon-bag2 snptlinked-item-ico\"></i></a><div class=\"snptcrd__ovrly\"><div class=\"ovrly_content snpt-atm sfx-scale-up\"><div class=\"snpt-atm-el sfx__animated\"><div class=\"snptcrd__button\"><i class=\"t-icon icon-bag2\"></i></div></div></div></div></div>"
                });
            k.run()
        },
        onUnload: function () {
            this.$container.off(this.collectionNamespace)
        }
    }), p
}(), theme.CollectionsTemplate = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.CollectionsId = $("#shopify-section-" + b), this.Collections = $("#unero-site-content"), this.CollectionsNamspace = "#unero-site-content", this.collection_infinite_scoll = this.Collections.data("collection_infinite_scoll"), this.collection_infinite_scoll_auto = this.Collections.data("collection_infinite_scoll_auto"), this.pInfScrLoading = !1, this.pInfScrMore = !0, this.flagScroll = !0, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            this._initCollectionControl()
        },
        _initCollectionControl: function () {
            var v = this;
            "1" == this.collection_infinite_scoll && ("1" == this.collection_infinite_scoll_auto && $(window).scroll(function () {
                var y = $(".load_more");
                if (0 < y.length) {
                    var b = $(window),
                        C = b.scrollTop(),
                        k = C + b.height(),
                        S = y.offset().top,
                        I = S + y.height();
                    I <= k && S >= C && v.flagScroll && (v.flagScroll = !1, y.find("a").trigger("click"))
                }
            }), jQuery(".load_more a").click(function (y) {
                return v._pInfScrExecute(), y.stopPropagation(), !1
            }))
        },
        _pInfScrExecute: function () {
            var v = this,
                y = $(".load_more").last(),
                b = $(".load_more a").last().attr("href");
            0 < y.length && v.pInfScrMore && $.ajax({
                type: "GET",
                url: b,
                beforeSend: function () {
                    jQuery(".load_more").hide(), jQuery("#un-products-loading").toggleClass("hide").fadeIn()
                },
                success: function (C) {
                    var k = $(C).find(".unero-post-list").children(".un-post-item");
                    if (k.imagesLoaded(function () {
                            $(".unero-post-list").append(k).isotope("insert", k)
                        }), jQuery("#un-products-loading").toggleClass("hide").fadeOut(), $(document.body).find("img.lazy").lazyload(), jQuery(C).find(".load_more a").length) {
                        jQuery(".load_more a").last().attr("href", jQuery(C).find(".load_more a").last().attr("href")), jQuery(".load_more").show(), v.flagScroll = !0;
                        var S = parseInt(jQuery(C).find(".load_more a").last().data("page"));
                        if (0 < S) {
                            var I = parseInt($(".page-num-offset").data("page_size")),
                                T = parseInt($(".page-num-offset").data("total_result")),
                                x = S * I;
                            T > x && $(".result-offset").html(x).css("padding-right", "5px")
                        } else $(".page-num-offset").html($(".page-num-offset").data("total_result"))
                    } else v.pInfScrMore = !1, jQuery(".load_more").remove(), $(".page-num-offset").html($(".page-num-offset").data("total_result"))
                },
                dataType: "html"
            })
        },
        _initReviews: function () {
            "undefined" != typeof SPR && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges())
        },
        onUnload: function () {
            this.$container.off(this.CollectionsNamspace)
        }
    }), p
}(), theme.BlogTemplate = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.BlogId = $("#shopify-section-" + b), this.Blog = $("#unero-site-content"), this.BlogNamspace = "#unero-site-content", this.collection_infinite_scoll = this.Blog.data("collection_infinite_scoll"), this.collection_infinite_scoll_auto = this.Blog.data("collection_infinite_scoll_auto"), this.sidebar = this.Blog.data("sidebar"), this.pInfScrLoading = !1, this.pInfScrMore = !0, this.flagScroll = !0, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            this._initCollectionControl(), "" != this.sidebar && $(document.body).removeClass("full-content").addClass(this.sidebar)
        },
        _initCollectionControl: function () {
            var v = this;
            "1" == this.collection_infinite_scoll && ("1" == this.collection_infinite_scoll_auto && $(window).scroll(function () {
                var y = $(".load_more");
                if (0 < y.length) {
                    var b = $(window),
                        C = b.scrollTop(),
                        k = C + b.height(),
                        S = y.offset().top,
                        I = S + y.height();
                    I <= k && S >= C && v.flagScroll && (v.flagScroll = !1, y.find("a").trigger("click"))
                }
            }), jQuery(".load_more a").click(function (y) {
                return v._pInfScrExecute(), y.stopPropagation(), !1
            }))
        },
        _pInfScrExecute: function () {
            var v = this,
                y = $(".load_more").last(),
                b = $(".load_more a").last().attr("href");
            0 < y.length && v.pInfScrMore && $.ajax({
                type: "GET",
                url: b,
                beforeSend: function () {
                    jQuery(".load_more").hide(), jQuery("#un-products-loading").toggleClass("hide").fadeIn()
                },
                success: function (C) {
                    var k = $(C).find(".unero-post-list").children(".un-post-item");
                    if ($("#unero-site-content").hasClass("blog-layout-masonry") ? k.imagesLoaded(function () {
                            $(".unero-post-list").append(k).isotope("insert", k)
                        }) : $(".unero-post-list").append(k), jQuery("#un-products-loading").toggleClass("hide").fadeOut(), $(document.body).find("img.lazy").lazyload(), jQuery(C).find(".load_more a").length) {
                        jQuery(".load_more a").last().attr("href", jQuery(C).find(".load_more a").last().attr("href")), jQuery(".load_more").show(), v.flagScroll = !0;
                        var S = parseInt(jQuery(C).find(".load_more a").last().data("page"));
                        if (0 < S) {
                            var I = parseInt($(".page-num-offset").data("page_size")),
                                T = parseInt($(".page-num-offset").data("total_result")),
                                x = S * I;
                            T > x && $(".result-offset").html(x).css("padding-right", "5px")
                        } else $(".page-num-offset").html($(".page-num-offset").data("total_result"))
                    } else v.pInfScrMore = !1, jQuery(".load_more").remove(), $(".page-num-offset").html($(".page-num-offset").data("total_result"))
                },
                dataType: "html"
            })
        },
        onUnload: function () {
            this.$container.off(this.BlogNamspace)
        }
    }), p
}(), theme.portfolioMasonry = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.portfolioId = $("#shopify-section-" + b), this.portfolio = $("#unero-site-content"), this.portfolioNamspace = "#unero-site-content", this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {},
        onUnload: function () {
            this.$container.off(this.portfolioNamspace)
        }
    }), p
}(), theme.portfolioCarousel = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.portfolioId = $("#shopify-section-" + b), this.portfolio = $("#unero-site-content"), this.portfolioNamspace = "#unero-site-content", this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {},
        onUnload: function () {
            this.$container.off(this.portfolioNamspace)
        }
    }), p
}(), theme.ArticleTemplate = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.articleId = $("#shopify-section-" + b), this.article = $(".article-" + b), this.articleNamspace = ".article-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            this._initRecommended()
        },
        _initRecommended: function () {
            var v = $(this.articleNamspace + " .related.products ul.products");
            0 < v.length && "1" == v.data("slide_enable") && v.not(".slick-initialized").slick({
                slidesToShow: v.data("per_view"),
                slidesToScroll: v.data("per_view"),
                arrows: !1,
                lazyLoad: "ondemand",
                dots: !0,
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }]
            })
        },
        onUnload: function () {
            this.$container.off(this.articleNamspace)
        }
    }), p
}(), theme.faqsTemplate = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.faqsId = $("#shopify-section-" + b), this.faqs = $("#content"), this.faqsNamspace = "#content", this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {},
        onUnload: function () {
            this.$container.off(this.faqsNamspace)
        }
    }), p
}(), theme.aboutTemplate = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.aboutId = $("#shopify-section-" + b), this.about = $("#content"), this.aboutNamspace = "#content", this.aboutSlide = $("#slide-" + b), this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            this._initSlide()
        },
        _initSlide: function () {
            var v = this.aboutSlide;
            v.not(".slick-initialized").slick({
                slidesToShow: parseInt(v.data("per_view")),
                slidesToScroll: 1,
                lazyLoad: "ondemand",
                dots: !1,
                arrows: !1,
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }]
            })
        },
        onUnload: function () {
            this.$container.off(this.aboutNamspace)
        }
    }), p
}(), theme.SliderSection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.sliderId = $("#shopify-section-" + b), this.slider = $("#" + b), this.sliderNamspace = "#" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            "1" == this.slider.data("parallax") ? ($(document.body).hasClass("header-slider-top") && $(document.body).removeClass("header-slider-noparallax"), $(document.body).removeClass("page-header-layout-1").addClass("page-header-layout-3"), function () {
                if (!$(".page-header").hasClass("page-header-sliders")) return void $(".page-header.parallax").parallax("50%", 0.6);
                var y = $(".page-header-sliders"),
                    b = y.data("speed"),
                    C = !1,
                    k = y.data("auto"),
                    S = y.data("parallax");
                if ("1" == S && (C = !0), y.find("ul").not(".slick-initialized").slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: !0,
                        autoplaySpeed: b,
                        autoplay: k,
                        fade: C,
                        cssEase: "linear",
                        prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                        nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>"
                    }), "0" == S) $(".page-header-sliders.parallax").find("li").parallax("50%", 0.6);
                else {
                    var I = y.height();
                    $(document.body).hasClass("admin-bar") && (I -= 32), $("#content").css("margin-top", I), y.addClass("parallax-2"), $(window).on("scroll", function () {
                        var T = $(window).scrollTop();
                        0 < T ? $(".page-header-sliders.parallax-2").css({
                            opacity: (I - T) / I
                        }) : $(".page-header-sliders.parallax-2").css({
                            opacity: 1
                        })
                    })
                }
            }()) : ($(document.body).hasClass("header-slider-top") && $(document.body).addClass("header-slider-noparallax"), $(document.body).addClass("page-header-layout-1")), this._initSlider()
        },
        _initSlider: function () {
            if (!this.slider.hasClass("page-header-sliders")) return void $(".page-header.parallax").parallax("50%", 0.6);
            var v = this.slider,
                y = v.data("speed"),
                b = !1,
                C = v.data("auto"),
                k = v.data("parallax");
            if ("1" == k && (b = !0), v.find("ul").not(".slick-initialized").slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: !0,
                    autoplaySpeed: y,
                    autoplay: C,
                    fade: b,
                    cssEase: "linear",
                    prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                    nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>"
                }), "" == k) $(".page-header-sliders.parallax").find("li").parallax("50%", 0.6);
            else {
                var S = v.height();
                $(document.body).hasClass("admin-bar") && (S -= 32), $("#content").css("margin-top", S), v.addClass("parallax-2"), $(window).on("scroll", function () {
                    var I = $(window).scrollTop();
                    0 < I ? $(".page-header-sliders.parallax-2").css({
                        opacity: (S - I) / S
                    }) : $(".page-header-sliders.parallax-2").css({
                        opacity: 1
                    })
                })
            }
        },
        onUnload: function () {
            this.$container.off(this.sliderNamspace)
        }
    }), p
}(), theme.uneroSliderSection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.uneroSliderId = $("#unero-sliders-wrapper-" + b), this.uneroSlider = $("#unero-sliders-" + b), this.uneroSliderNamspace = "#unero-sliders-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            this._initUneroSlide()
        },
        _initUneroSlide: function () {
            var v = !1,
                y = !1,
                b = !1,
                C = parseInt(this.uneroSliderId.data("height")),
                k = parseInt(this.uneroSliderId.data("parallax")),
                S = this.uneroSliderId.data("speed"),
                I = this.uneroSliderId.data("autoplay"),
                T = "1" == this.uneroSliderId.data("dots"),
                x = this.uneroSlider;
            "1" == this.uneroSliderId.data("autoplay") && (v = !0), "1" == k && (y = !0), "1" == this.uneroSliderId.data("direction") && (b = !0), x.not(".slick-initialized").slick({
                rtl: b,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplaySpeed: S,
                dots: T,
                autoplay: I,
                infinite: v,
                fade: y,
                lazyLoad: "ondemand",
                prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>"
            }), $(window).on("resize", function () {
                if (0 < C) {
                    var N = $(window).width();
                    x.height(N * C / 1903)
                }
            }).trigger("resize"), "1" == k && x.find(".featured-img").parallax("50%", 0.6), x.imagesLoaded(function () {
                x.addClass("loaded")
            });
            var P = x.find(".unvideo-bg").find("video");
            0 < P.length && P[0].play(), x.on("afterChange", function (N, B, A) {
                var z = x.find(".slick-slide[data-slick-index=\"" + A + "\"]").find("video");
                0 < z.length && z[0].play()
            }), x.on("beforeChange", function (N, B, A) {
                var z = x.find(".slick-slide[data-slick-index=\"" + A + "\"]").find("video");
                0 < z.length && z[0].pause()
            })
        },
        onUnload: function () {
            this.$container.off(this.uneroSliderNamspace)
        }
    }), p
}(), theme.uneroHeroSliderSection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.uneroHeroSliderId = $("#shopify-section-" + b), this.uneroHeroSlider = $("#unero-hero-slider-" + b), this.uneroHeroSliderNamspace = "#unero-hero-slider-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            this._initUneroHeroSlide()
        },
        _initUneroHeroSlide: function () {
            $(".unero-hero-slider").on("mouseover touchstart", ".item-content", function () {
                var v = $(this),
                    y = v.index(),
                    b = v.closest(".unero-hero-slider").find(".item-image");
                b.removeClass("active"), v.siblings().removeClass("active"), v.addClass("active"), b.filter(":eq(" + y + ")").addClass("active")
            })
        },
        onUnload: function () {
            this.$container.off(this.uneroHeroSliderNamspace)
        }
    }), p
}(), theme.uneroCollectionsSection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.uneroCollectionsId = $("#unero-banners-carousel-" + b), this.uneroCollections = $("#banners-carousel-" + b), this.uneroCollectionsNamspace = "#banners-carousel-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            "1" == this.uneroCollectionsId.data("slide_enable") && this._initUneroCollections()
        },
        _initUneroCollections: function () {
            var v = !1,
                y = !1,
                b = this.uneroCollectionsId.data("speed"),
                C = this.uneroCollectionsId.data("autoplay"),
                k = this.uneroCollectionsId.data("perview"),
                S = this.uneroCollections;
            "1" == this.uneroCollectionsId.data("autoplay") && (v = !0), "1" == this.uneroCollectionsId.data("direction") && (y = !0), S.not(".slick-initialized").slick({
                rtl: y,
                slidesToShow: k,
                slidesToScroll: 1,
                autoplaySpeed: b,
                autoplay: C,
                infinite: v,
                lazyLoad: "ondemand",
                prevArrow: "<span class=\"icon-arrow-left slick-prev-arrow\"></span>",
                nextArrow: "<span class=\"icon-arrow-right slick-next-arrow\"></span>",
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            }), S.imagesLoaded(function () {
                S.addClass("loaded")
            })
        },
        onUnload: function () {
            this.$container.off(this.uneroCollectionsNamspace)
        }
    }), p
}(), theme.uneroCollectionsMasonrySection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.uneroCollectionsId = $("#shopify-section-" + b), this.uneroCollections = $("#unero-collections-masonry-wrapper-" + b), this.uneroCollectionsNamspace = "#unero-collections-masonry-wrapper-" + b, this.uneroBanner = $(".unero-banner-" + b), this.uneroNewsletter = $("#mc-form.newsletter-" + b), this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            0 < this.uneroBanner.length && this.uneroBanner.each(function () {
                var v = $(this).find(".text").width(),
                    y = -1 * (v / 2 + 25),
                    b = $(this).find(".data-height").data("height");
                $(this).hasClass("text-align-left") ? $(this).find(".text").css("left", y) : $(this).find(".text").css("right", y), $(this).hasClass("text-position-center") && $(this).find(".text").css("top", (b - v) / 2)
            }), 0 < this.uneroNewsletter.length && this._initNewsletter()
        },
        _initNewsletter: function () {
            function v() {}
            var y = this.uneroNewsletter,
                b = y.attr("action");
            y.ajaxChimp({
                url: b,
                callback: function (C) {
                    "success" === C.result && v()
                }
            })
        },
        onUnload: function () {
            this.$container.off(this.uneroCollectionsNamspace)
        }
    }), p
}(), theme.uneroBannerSection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.uneroBannerId = $("#shopify-section-" + b), this.uneroBanner = $("#unero-banners-grid-" + b), this.uneroBannerNamspace = "#unero-banners-grid-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {},
        onUnload: function () {
            this.$container.off(this.uneroBannerNamspace)
        }
    }), p
}(), theme.uneroBannerMetroSection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.uneroBannerId = $("#shopify-section-" + b), this.uneroBanner = $("#unero-banners-metro-" + b), this.uneroBannerNamspace = "#unero-banners-metro-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            this._initMasonry()
        },
        _initMasonry: function () {
            var v = this.uneroBanner;
            v.find(".unero-banners-metro-content").imagesLoaded(function () {
                v.find(".unero-banners-metro-content").isotope({
                    itemSelector: ".banner-item",
                    layoutMode: "packery"
                })
            })
        },
        onUnload: function () {
            this.$container.off(this.uneroBannerNamspace)
        }
    }), p
}(), theme.uneroAboutSection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.uneroAboutId = $("#shopify-section-" + b), this.uneroAbout = $("#unero-about-wrapper-" + b), this.uneroAboutNamspace = "#unero-about-wrapper-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {},
        onUnload: function () {
            this.$container.off(this.uneroAboutNamspace)
        }
    }), p
}(), theme.uneroProductsCarouselSection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.carouselId = $("#unero-products-carousel-wrapper-" + b), this.carousel = $(".unero-products-carousel-" + b), this.carouselNamspace = "#unero-products-carousel-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            0 < this.carousel.length && this.carousel.each(function () {
                if ("1" == $(this).data("slide")) {
                    var v = $(this),
                        y = $(this).data("perview"),
                        b = $(this).data("autoplay"),
                        C = $(this).data("speed"),
                        k = !1;
                    "1" == b && (k = !0), v.not(".slick-initialized").slick({
                        rtl: !1,
                        slidesToShow: y,
                        slidesToScroll: 1,
                        autoplaySpeed: C,
                        autoplay: b,
                        infinite: k,
                        lazyLoad: "ondemand",
                        prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                        nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>",
                        responsive: [{
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        }]
                    })
                }
            })
        },
        onUnload: function () {
            this.$container.off(this.carouselNamspace)
        }
    }), p
}(), theme.uneroInstagramSection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.uneroInstagramId = $("#unero-instagram-wrapper-" + b), this.uneroInstagram = $("#unero-instagram-" + b), this.uneroInstagramNamspace = "#unero-instagram-" + b, this.uneroInstagramTarget = "unero-instagram-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            "carousel" == this.uneroInstagram.data("type") ? this._initCarousel() : this._initGrid()
        },
        _initGrid: function () {
            var v = this.uneroInstagram,
                y = this.uneroInstagramTarget,
                b = v.attr("data-id"),
                C = v.attr("data-token"),
                k = v.attr("data-limit"),
                S = new Instafeed({
                    get: "user",
                    target: y,
                    accessToken: C,
                    userId: parseInt(b),
                    limit: parseInt(k),
                    resolution: "standard_resolution",
                    resolution2: "standard_resolution",
                    template: "<div class=\"wrap animated\"><a class=\"fauximg-bin\" target=\"_blank\" href=\"{{link}}\"><figure class=\"snpt__fauximg\" style=\"background-image: url({{image}})\"></figure><i class=\"t-icon icon-bag2 snptlinked-item-ico\"></i></a><div class=\"snptcrd__ovrly\"><div class=\"ovrly_content snpt-atm sfx-scale-up\"><div class=\"snpt-atm-el sfx__animated\"><div class=\"snptcrd__button\"><i class=\"t-icon icon-bag2\"></i></div></div></div></div></div>"
                });
            S.run()
        },
        _initCarousel: function () {
            var v = this.uneroInstagram,
                y = this.uneroInstagramTarget,
                b = v.attr("data-id"),
                C = v.attr("data-token"),
                k = v.attr("data-limit"),
                S = v.data("perview"),
                I = v.data("autoplay"),
                T = !1,
                x = v.data("speed"),
                P = new Instafeed({
                    get: "user",
                    target: y,
                    accessToken: C,
                    userId: parseInt(b),
                    limit: parseInt(k),
                    resolution: "low_resolution",
                    resolution2: "standard_resolution",
                    template: "<li class=\"product\"><a class=\"insta-item\" target=\"_blank\" href=\"{{link}}\"><img src=\"{{image}}\" alt=\"{{caption}}\" /><i class=\"social_instagram\"></i></a></li>",
                    after: function () {
                        0 < I ? (T = !0, I = !0) : I = !1, v.not(".slick-initialized").slick({
                            slidesToShow: S,
                            slidesToScroll: 1,
                            autoplaySpeed: x,
                            autoplay: I,
                            infinite: T,
                            dots: !1,
                            prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                            nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>",
                            responsive: [{
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 1
                                }
                            }, {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1
                                }
                            }]
                        })
                    }
                });
            P.run()
        },
        onUnload: function () {
            this.$container.off(this.uneroInstagramNamspace)
        }
    }), p
}(), theme.unseroBlogSection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.unseroBlogId = $("#shopify-section-" + b), this.unseroBlog = $("#unero-posts-" + b), this.unseroBlogNamspace = "#unero-posts-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {},
        onUnload: function () {
            this.$container.off(this.unseroBlogNamspace)
        }
    }), p
}(), theme.toTopSection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.toTopId = $("#shopify-section-" + b), this.toTop = $("#to-top-" + b), this.toTopNamespace = "#to-top-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            this._initToTop()
        },
        _initToTop: function () {
            var C = $(".cd-top");
            $(window).scroll(function () {
                $(this).scrollTop() > 300 ? C.addClass("cd-is-visible") : C.removeClass("cd-is-visible cd-fade-out"), $(this).scrollTop() > 1200 && C.addClass("cd-fade-out")
            }), C.on("click", function (k) {
                k.preventDefault(), $("body,html").animate({
                    scrollTop: 0
                }, 700)
            })
        },
        onUnload: function () {
            this.$container.off(this.toTopNamespace)
        }
    }), p
}(), theme.unseroNewsletterSection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.unseroNewsletterId = $("#shopify-section-" + b), this.unseroNewsletter = $("#unero-newsletter-" + b), this.unseroNewsletterNamspace = "#unero-newsletter-" + b, this.uneroNewsletterForm = $("#mc-form.newsletter-" + b), this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            function v() {}
            var y = this.uneroNewsletterForm,
                b = y.attr("action");
            y.ajaxChimp({
                url: b,
                callback: function (C) {
                    "success" === C.result && v()
                }
            })
        },
        onUnload: function () {
            this.$container.off(this.unseroNewsletterNamspace)
        }
    }), p
}(), theme.uneroProductTabsSection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.productTabsId = $("#product-tabs-wrapper-" + b), this.productTabs = $("#product-tabs-wrapper-" + b), this.productTabsNamspace = "#product-tabs-wrapper-" + b, this.productTabsShop = $("#product-tabs-wrapper-" + b + " .product-tabs-masonry-2"), this.productTabsBlog = $("#product-tabs-wrapper-" + b + " .product-tabs-masonry-3"), this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            this._initTab(), 0 < this.productTabsShop.length && this._initShopLayout(), "1" == this.productTabs.data("animation") && this._animationProduct()
        },
        _initTab: function () {
            $(this.productTabsNamspace + " .product-tabs").off("click").on("click", "ul.tabs li a", function (v) {
                if (v.preventDefault(), $(this).parent("li").hasClass("active")) return !1;
                var y = $(this),
                    b = y.closest(".product-tabs"),
                    C = b.find("ul.tabs"),
                    k = $(y.attr("href")).find("ul.products");
                return C.find("li").removeClass("active"), $(this).parent("li").addClass("active"), b.find(".panel:visible").fadeOut(300, function () {
                    b.find(y.attr("href")).fadeIn(300, function () {
                        $(y.attr("href")).hasClass("product-tabs-masonry-2") && new Isotope(".product-tabs-masonry-2 .products")
                    })
                }), !1
            })
        },
        _initShopLayout: function () {
            var v = this.productTabsShop;
            $(document.body).imagesLoaded(function () {
                v.each(function () {
                    $(this).find("ul.products").isotope({
                        itemSelector: "li.product",
                        layoutMode: "masonry"
                    })
                })
            })
        },
        _animationProduct: function () {
            var v = $(document.body).find(".un-shop-content .product-inner");
            v.removeAttr("data-sr-id").removeAttr("style");
            window.sr = new ScrollReveal({
                viewFactor: 0.15,
                duration: 1e3,
                scale: 0.9,
                opacity: 1,
                easing: "ease"
            });
            sr.reveal(v, {
                reset: !0,
                viewOffset: {
                    top: 64
                }
            })
        },
        onUnload: function () {
            this.$container.off(this.productTabsNamspace)
        }
    }), p
}(), theme.unseroStaticBlockSection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.unseroStaticBlockId = $("#shopify-section-" + b), this.unseroStaticBlock = $("#static-block-" + b), this.unseroStaticBlockNamspace = "#static-block-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            0 == this.unseroStaticBlockId.prev().length && ("1" == this.unseroStaticBlock.data("mix_header") ? $(document.body).addClass("mix-header") : $(document.body).removeClass("mix-header"))
        },
        onUnload: function () {
            this.$container.off(this.unseroStaticBlockNamspace)
        }
    }), p
}(), theme.uneroTestimonial = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.uneroTestimonialId = $("#shopify-section-" + b), this.uneroTestimonial = $("#testimonial-" + b), this.uneroTestimonialNamspace = "#testimonial-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            this.uneroTestimonial.not(".slick-initialized").slick({
                rtl: !1,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplaySpeed: 5e3,
                autoplay: !0,
                infinite: !0,
                lazyLoad: "ondemand",
                prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>",
                responsive: []
            })
        },
        onUnload: function () {
            this.$container.off(this.uneroTestimonialNamspace)
        }
    }), p
}();

function onYouTubeIframeAPIReady() {
    theme.YouTubeVideos.loadVideos()
}
theme.YouTubeVideos = function () {
    function C(z) {
        return N[z.target.h.id]
    }

    function k() {
        $(".home_video_bg").each(function (z, D) {
            S($(D))
        })
    }

    function S(z) {
        var D = z.closest(".home-video"),
            U = z,
            O = D.width(),
            q = D.height(),
            M = U.width(),
            V = U.height();
        O / A.ratio < V ? (M = Math.ceil(V * A.ratio), z.width(M).height(V).css({
            left: (O - M) / 2,
            top: 0
        })) : (V = Math.ceil(O / A.ratio), z.width(O).height(V).css({
            left: 0,
            top: (V - V) / 2
        })), D.height(V), z.addClass("home_video_loaded")
    }

    function x() {
        $(window).on("resize.videoPlayer", $.debounce(250, function () {}))
    }
    var P = !1,
        N = {},
        B = [],
        A = {
            ratio: 16 / 9,
            playerVars: {
                modestbranding: 1,
                autoplay: 1,
                controls: 0,
                showinfo: 0,
                branding: 0,
                rel: 0,
                autohide: 1,
                cc_load_policy: 1,
                disablekb: 0,
                fs: 1,
                iv_load_policy: 3,
                start: 0,
                end: 0,
                loop: 1,
                rel: 0
            },
            events: {
                onReady: function (z) {
                    var D = C(z);
                    D.playerId.addClass("home_video_bg"), z.target.setPlaybackQuality("hd1080"), z.target.mute(), z.target.setLoop(!0), k()
                },
                onStateChange: function (z) {
                    var D = C(z);
                    switch (z.data) {
                        case 0:
                            B[D.id].seekTo(D.playerVars.start);
                            break;
                        case 1:
                            break;
                        case 2:
                    }
                }
            }
        };
    return {
        init: function (z) {
            if (z.id && (N[z.id] = {
                    id: z.id,
                    playerId: z.player_id,
                    videoId: z.video_id,
                    homeVideo: z.home_video,
                    videoSelector: z.id,
                    playerVars: z.playerDefaults
                }, !P)) {
                var D = document.createElement("script");
                D.src = "https://www.youtube.com/iframe_api";
                var U = document.getElementsByTagName("script")[0];
                U.parentNode.insertBefore(D, U)
            }
        },
        loadVideos: function () {
            for (var M in N)
                if (N.hasOwnProperty(M)) {
                    var V = $.extend({}, A, N[M]);
                    V.playerId.addClass("home_video_bg"), B[M] = new YT.Player(M, V)
                } k(), x(), P = !0
        },
        loadVideo: function (z) {
            if (P) {
                var D = $.extend({}, A, N[z]);
                B[z] = new YT.Player(z, D), x()
            }
        }
    }
}(), theme.uneroVideos = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.videoId = $("#shopify-section-" + b), this.videoNamspace = "#home-video-" + b, this.VideoHomeId = $(this.videoNamspace), this.PlayerNamespace = "playerYoutube-" + b, this.PlayerId = $("#playerYoutube-" + b), this.VideoHomeWidth = $(this.videoNamspace + " .video_width"), this.options = {
            video_type: this.VideoHomeId.data("video_type")
        }, this.video_start = this.VideoHomeId.data("video_start");
        var k = this.VideoHomeId.data("video_duration");
        this.video_end = parseInt(this.video_start) + parseInt(k), "yt-video" == this.options.video_type && this._handleYoutubeVideo()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _handleYoutubeVideo: function () {
            var v = {
                id: this.PlayerNamespace,
                video_id: this.PlayerId.data("video_id"),
                home_video: this.VideoHomeId,
                player_id: this.PlayerId,
                playerDefaults: {
                    modestbranding: 1,
                    autoplay: 1,
                    controls: 0,
                    showinfo: 0,
                    branding: 0,
                    rel: 0,
                    autohide: 1,
                    start: this.video_start,
                    end: this.video_end
                }
            };
            window.home_video_list[v.id] = v, theme.YouTubeVideos.init(v), theme.YouTubeVideos.loadVideo(v.id)
        },
        onUnload: function () {
            this.$container.off(this.videoNamspace)
        },
        onSelect: function () {},
        onBlockSelect: function () {},
        onBlockDeselect: function () {}
    }), p
}(), theme.uneroBrands = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.brandsId = $("#brands-" + b), this.brands = $(".brands-" + b), this.featuredBrands = $(".featured-brands-" + b), this.brandsNamspace = "#brands-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            var v = this.featuredBrands.data("perview"),
                y = this.featuredBrands.data("autoplay"),
                b = this.featuredBrands.data("speed"),
                C = !1;
            "1" == y && (C = !0), this.featuredBrands.not(".slick-initialized").slick({
                rtl: !1,
                slidesToShow: v,
                slidesToScroll: 1,
                autoplaySpeed: b,
                autoplay: y,
                infinite: !0,
                lazyLoad: "ondemand",
                prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>",
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }]
            })
        },
        onUnload: function () {
            this.$container.off(this.brandsNamspace)
        }
    }), p
}(), theme.gridsSection = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.gridsId = $("#grid-wrapper-" + b), this.grids = $("#grid-wrapper-" + b), this.gridsNamspace = "#grid-wrapper-" + b, this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            var v = this.sectionId,
                y = function () {
                    function k(R) {
                        A.each(function () {
                            var W = $(this);
                            W.data("offsetTop", W.offset().top), R && W.data("height", W.height())
                        })
                    }

                    function S() {
                        I(A), q.on("debouncedresize", function () {
                            U = 0, D = -1, k(), T();
                            var R = $.data(this, "preview");
                            "undefined" != typeof R && P()
                        })
                    }

                    function I(R) {
                        R.on("click", "span.og-close", function () {
                            return P(), !1
                        }).children("a").on("click", function () {
                            var G = $(this).parent();
                            return z === G.index() ? P() : x(G), !1
                        })
                    }

                    function T() {
                        M = {
                            width: q.width(),
                            height: q.height()
                        }
                    }

                    function x(R) {
                        var W = $.data(this, "preview"),
                            G = R.data("offsetTop");
                        if (U = 0, "undefined" != typeof W)
                            if (D !== G) G > D && (U = W.height), P();
                            else return W.update(R), !1;
                        D = G, W = $.data(this, "preview", new N(R)), W.open()
                    }

                    function P() {
                        z = -1;
                        var R = $.data(this, "preview");
                        R.close(), $.removeData(this, "preview")
                    }

                    function N(R) {
                        this.$item = R, this.expandedIdx = this.$item.index(), this.create(), this.update()
                    }
                    var M, B = $("#og-grid-" + v),
                        A = B.children("li"),
                        z = -1,
                        D = -1,
                        U = 0,
                        O = 10,
                        q = $(window),
                        V = $("html, body"),
                        E = {
                            WebkitTransition: "webkitTransitionEnd",
                            MozTransition: "transitionend",
                            OTransition: "oTransitionEnd",
                            msTransition: "MSTransitionEnd",
                            transition: "transitionend"
                        } [Modernizr.prefixed("transition")],
                        H = Modernizr.csstransitions,
                        F = {
                            minHeight: 500,
                            speed: 350,
                            easing: "ease"
                        };
                    return N.prototype = {
                        create: function () {
                            this.$title = $("<h3></h3>"), this.$description = $("<p></p>"), this.$href = $("<a class=\"button\" href=\"#\"><span></span></a>"), this.$details = $("<div class=\"og-details\"></div>").append(this.$title, this.$description, this.$href), this.$loading = $("<div class=\"og-loading\"></div>"), this.$fullimage = $("<div class=\"og-fullimg\"></div>").append(this.$loading), this.$closePreview = $("<span class=\"og-close\"></span>"), this.$previewInner = $("<div class=\"og-expander-inner\"></div>").append(this.$closePreview, this.$fullimage, this.$details), this.$previewEl = $("<div class=\"og-expander\"></div>").append(this.$previewInner), this.$item.append(this.getEl()), H && this.setTransition()
                        },
                        update: function (R) {
                            if (R && (this.$item = R), -1 != z) {
                                var W = A.eq(z);
                                W.removeClass("og-expanded"), this.$item.addClass("og-expanded"), this.positionPreview()
                            }
                            z = this.$item.index();
                            var G = this.$item.children("a"),
                                K = {
                                    href: G.attr("href"),
                                    largesrc: G.data("largesrc"),
                                    title: G.data("title"),
                                    cta: G.data("cta"),
                                    description: G.data("description")
                                };
                            this.$title.html(K.title), this.$description.html(K.description), this.$href.html("<span>" + K.cta + "</span>"), this.$href.attr("href", K.href);
                            var Q = this;
                            "undefined" != typeof Q.$largeImg && Q.$largeImg.remove(), Q.$fullimage.is(":visible") && (this.$loading.show(), $("<img/>").load(function () {
                                var Y = $(this);
                                Y.attr("src") === Q.$item.children("a").data("largesrc") && (Q.$loading.hide(), Q.$fullimage.find("img").remove(), Q.$largeImg = Y.fadeIn(350), Q.$fullimage.append(Q.$largeImg))
                            }).attr("src", K.largesrc))
                        },
                        open: function () {
                            setTimeout($.proxy(function () {
                                this.setHeights(), this.positionPreview()
                            }, this), 25)
                        },
                        close: function () {
                            var R = this,
                                W = function () {
                                    H && $(this).off(E), R.$item.removeClass("og-expanded"), R.$previewEl.remove()
                                };
                            return setTimeout($.proxy(function () {
                                "undefined" != typeof this.$largeImg && this.$largeImg.fadeOut("fast"), this.$previewEl.css("height", 0);
                                var G = A.eq(this.expandedIdx);
                                G.css("height", G.data("height")).on(E, W), H || W.call()
                            }, this), 25), !1
                        },
                        calcHeight: function () {
                            var R = M.height - this.$item.data("height") - O,
                                W = M.height;
                            R < F.minHeight && (R = F.minHeight, W = F.minHeight + this.$item.data("height") + O), this.height = R, this.itemHeight = W
                        },
                        setHeights: function () {
                            var R = this,
                                W = function () {
                                    H && R.$item.off(E), R.$item.addClass("og-expanded")
                                };
                            this.calcHeight(), this.$previewEl.css("height", this.height), this.$item.css("height", this.itemHeight).on(E, W), H || W.call()
                        },
                        positionPreview: function () {
                            var R = this.$item.data("offsetTop"),
                                W = this.$previewEl.offset().top - U,
                                G = this.height + this.$item.data("height") + O <= M.height ? R : this.height < M.height ? W - (M.height - this.height) : W;
                            V.animate({
                                scrollTop: G
                            }, F.speed)
                        },
                        setTransition: function () {
                            this.$previewEl.css("transition", "height " + F.speed + "ms " + F.easing), this.$item.css("transition", "height " + F.speed + "ms " + F.easing)
                        },
                        getEl: function () {
                            return this.$previewEl
                        }
                    }, {
                        init: function (R) {
                            F = $.extend(!0, {}, F, R), B.imagesLoaded(function () {
                                k(!0), T(), S()
                            })
                        },
                        addItems: function (R) {
                            A = A.add(R), R.each(function () {
                                var W = $(this);
                                W.data({
                                    offsetTop: W.offset().top,
                                    height: W.height()
                                })
                            }), I(R)
                        }
                    }
                }();
            $(function () {
                y.init()
            })
        },
        onUnload: function () {
            this.$container.off(this.gridsNamspace)
        }
    }), p
}(), theme.CollectionCarouselTemplate = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.CollectionId = $("#collection-" + b), this.Collection = $("#collection-" + b), this.CollectionNamspace = "#collection-" + b, this.carouselSlide = $(".unero-products-carousel-" + b), this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            0 < this.carouselSlide.length && this.carouselSlide.each(function () {
                var v = $(this),
                    y = $(this).data("per_view"),
                    b = $(this).data("autoplay"),
                    C = $(this).data("speed"),
                    k = !1;
                "1" == b && (k = !0), v.find(".unero-products-carousel-slide").not(".slick-initialized").slick({
                    rtl: !1,
                    slidesToShow: y,
                    slidesToScroll: 1,
                    autoplaySpeed: C,
                    autoplay: b,
                    infinite: k,
                    lazyLoad: "ondemand",
                    prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                    nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>",
                    responsive: [{
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    }]
                })
            })
        },
        onUnload: function () {
            this.$container.off(this.CollectionNamspace)
        }
    }), p
}(), theme.ProductVariantMobile = function () {
    function p(v) {
        var y = this.$container = $(v),
            b = this.sectionId = y.attr("data-section-id"),
            C = y.attr("data-section-type");
        this.wrapperId = $("#" + b), this.wrapper = $("#" + b), this.wrapperNamspace = "#" + b, this.addCartId = $("#btn-" + b + ".m-allow-cart"), this.addCartClass = $(".variant-item-" + b + ".m-allow-cart"), this._init()
    }
    return p.prototype = _.assignIn({}, p.prototype, {
        _init: function () {
            var v = this;
            v._initCompact(), v._initEvents(), $(window).resize(function () {
                767 >= $(window).width() && v._initCompact()
            })
        },
        _initCompact: function () {
            if (0 < $(".product-variant-mobile-section").length) {
                var v = $(".product-variant-mobile-section"),
                    y = $(".product-variants-mobile");
                y.each(function () {
                    var b = $(this),
                        C = b.find(".variants-header"),
                        k = C.innerHeight(),
                        S = b.find(".variants-content").outerHeight(),
                        I = C.closest(".product-variants-mobile");
                    C.data("height", k), b.data("height", k + S)
                }), y.each(function () {
                    var b = $(this),
                        C = b.find(".variants-header"),
                        k = C.innerHeight(),
                        S = b.find(".variants-content").outerHeight(),
                        I = C.closest(".product-variants-mobile");
                    C.data("height", k), b.data("height", k + S), I.hasClass("active") && I.height(I.data("height"))
                }), v.unbind("click") && v.on("click", ".variants-header .title", function () {
                    var b = $(this),
                        C = b.closest(".variants-header"),
                        k = b.closest(".product-variants-mobile");
                    k.hasClass("active") || y.closest(".active").removeClass("active").height(b.data("height")), k.toggleClass("active"), k.hasClass("active") ? k.height(k.data("height")) : k.height(C.data("height"))
                })
            }
        },
        _initEvents: function () {
            var v = $("#ProductSelect-product-template.variation-select").val();
            0 < this.addCartId.length && (this.addCartId.unbind("click"), this.addCartId.on("click", function () {
                $("#ProductSelect-product-template.variation-select").val(v), $("#AddToCart-product-template").trigger("click")
            })), 0 < this.addCartClass.length && (this.addCartClass.unbind("click"), this.addCartClass.on("click", function () {
                var y = $(this).data("id");
                $("#ProductSelect-product-template.variation-select").val(y), $("#AddToCart-product-template").trigger("click")
            }))
        },
        onUnload: function () {
            this.$container.off(this.wrapperNamspace)
        }
    }), p
}(), $(document).ready(function () {
    var p = new theme.Sections;
    p.register("product-template", theme.Product), p.register("product-template-variant", theme.Product), p.register("product-variant-mobile", theme.ProductVariantMobile), p.register("cart-template", theme.Cart), p.register("search-template", theme.SearchTemplate), p.register("blog-template", theme.BlogTemplate), p.register("article-template", theme.ArticleTemplate), p.register("collection-template", theme.CollectionTemplate), p.register("collection-carousel-template", theme.CollectionCarouselTemplate), p.register("collections-template", theme.CollectionsTemplate), p.register("portfolio-masonry-template", theme.portfolioMasonry), p.register("collection-instagram-template", theme.CollectionInstagramTemplate), p.register("faqs-template", theme.faqsTemplate), p.register("contact-template", theme.Maps), p.register("about-template", theme.aboutTemplate), p.register("footer-section", theme.footerSection), p.register("menu-sidebar-section", theme.sideBarSection), p.register("mobile-nav-section", theme.mobileNavSection), p.register("header-section", theme.HeaderSection), p.register("totop-section", theme.toTopSection), p.register("header-slider", theme.SliderSection), p.register("unero-slider-section", theme.uneroSliderSection), p.register("unero-hero-slider-section", theme.uneroHeroSliderSection), p.register("unero-collections-section", theme.uneroCollectionsSection), p.register("unero-collections-masonry-section", theme.uneroCollectionsMasonrySection), p.register("unero-featured-collections-section", theme.uneroProductsCarouselSection), p.register("unero-product-tabs-section", theme.uneroProductTabsSection), p.register("unero-about-section", theme.uneroAboutSection), p.register("unero-banner-grid-section", theme.uneroBannerSection), p.register("unero-banner-metro-section", theme.uneroBannerMetroSection), p.register("unero-instagram-section", theme.uneroInstagramSection), p.register("unero-blog-section", theme.unseroBlogSection), p.register("unero-newsletter-section", theme.unseroNewsletterSection), p.register("unero-static-block", theme.unseroStaticBlockSection), p.register("unero-testimonial-section", theme.uneroTestimonial), p.register("unero-video-section", theme.uneroVideos), p.register("unero-brand-section", theme.uneroBrands), p.register("slideshow-section", theme.SlideshowSection), p.register("products", theme.Products), p.register("blog", theme.Blog), p.register("collections", theme.Collections), p.register("grid-view", theme.gridsSection)
}), window.theme = theme || {}, theme.roarApplication = function () {
    function p() {
        "undefined" != typeof SPR && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges())
    }

    function v() {
        $.ajax({
            url: "/search",
            beforeSend: function () {
                $("#cart-panel").addClass("loading")
            },
            success: function (se) {
                var ie = "#icon-cart-contents .mini-cart-counter",
                    re = "div#cart-panel";
                $(ie).html($(se).find(ie).html()), $(re).html($(se).filter(re).html()), theme.CurrencyPicker.convert("#cart-panel .money")
            },
            error: function (se) {
                console.log(se)
            }
        }).done(function () {
            $("#cart-panel").removeClass("loading")
        })
    }

    function y() {
        0 < $(".add_to_cart_variant_button").length && $(".add_to_cart_variant_button").unbind("click"), $(document).on("click", ".add_to_cart_variant_button", function () {
            var se = $(this);
            return se.hasClass("disabled") ? alert(theme.strings.alert_variant) : (Shopify.queue = [], jQuery(".qty-variant").each(function () {
                Shopify.queue.push({
                    variantId: jQuery(this).data("variant_id"),
                    quantity: parseInt(jQuery(this).val(), 10) || 0
                })
            }), Shopify.moveAlong = function () {
                if (console.log(Shopify.queue), Shopify.queue.length) var ie = Shopify.queue.shift(),
                    re = $.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        async: !0,
                        cache: !1,
                        data: {
                            quantity: ie.quantity,
                            id: ie.variantId
                        },
                        dataType: "json",
                        beforeSend: function () {
                            se.addClass("loading")
                        },
                        complete: function () {
                            v()
                        },
                        error: function (ne) {
                            var le = $.parseJSON(ne.responseText),
                                de = le.message + ": " + le.description;
                            alert(de)
                        },
                        success: function () {
                            Shopify.moveAlong()
                        }
                    });
                else "" == theme.cart_ajax ? window.location.href = "/cart" : (se.removeClass("loading"), I(), $(document.body).toggleClass("display-cart"), V($("#cart-panel")))
            }, Shopify.moveAlong()), !1
        })
    }

    function b() {
        $(document).on("click", ".add_to_cart_button", function () {
            var se = $(this),
                ie = se.closest("form");
            return "" == theme.cart_ajax ? (ie.submit(), !1) : ($.ajax({
                type: "POST",
                url: "/cart/add.js",
                async: !0,
                cache: !1,
                data: ie.serialize(),
                dataType: "json",
                beforeSend: function () {
                    se.addClass("loading")
                },
                complete: function () {
                    v()
                },
                error: function (re) {
                    var ne = $.parseJSON(re.responseText),
                        le = ne.message + ": " + ne.description;
                    se.removeClass("loading"), alert(le)
                },
                success: function () {}
            }).done(function () {
                se.removeClass("loading"), I(), $(document.body).toggleClass("display-cart"), V($("#cart-panel"))
            }), !1)
        })
    }

    function C() {
        $(document).on("focus", "#cart-panel .update", function () {
            $(this).select()
        }).on("blur", "#cart-panel .update", function () {
            var se = $(this),
                ie = se.val(),
                re = se.attr("data-id");
            $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=" + ie + "&id=" + re,
                dataType: "json",
                beforeSend: function () {
                    $("#cart-panel").addClass("loading")
                },
                success: function () {
                    v()
                },
                error: function (le, de) {
                    Shopify.onError(le, de)
                }
            })
        })
    }

    function k() {
        $(document).on("click", "#cart-panel .remove", function (se) {
            se.preventDefault();
            var ie = $(this),
                re = ie.attr("data-id");
            $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: "quantity=0&id=" + re,
                dataType: "json",
                beforeSend: function () {
                    ie.closest("#cart-panel").addClass("loading")
                },
                success: function () {
                    v()
                },
                error: function (le, de) {
                    Shopify.onError(le, de)
                }
            })
        })
    }

    function S(se) {
        $(document.body).addClass("modal-open"), se.fadeIn(), se.addClass("open")
    }

    function I() {
        $(document.body).removeClass("modal-open"), $(".unero-modal").fadeOut(function () {
            $(document.body).find("#menu-extra-search, #menu-extra-login").removeClass("show"), $(this).removeClass("open")
        })
    }

    function T() {
        $(document.body).on("click", ".product-quick-view, .un-product-link", function (se) {
            se.preventDefault();
            var ie = $(this),
                re = ie.attr("href"),
                ne = $("#quick-view-modal"),
                le = ne.find(".container"),
                de = ne.find(".modal-header .close-modal").first().clone(),
                ce = $(this).data("ptnamespace");
            ie.addClass("loading"), le.hide().html("").addClass("invisible"), ne.addClass("loading"), S(ne), $.get(re, function (pe) {
                le.html($(pe)), ne.removeClass("loading"), ie.removeClass("loading"), le.show().removeClass("invisible"), M(), p();
                var ue = new theme.Sections;
                ue.register(ce, theme.Product), theme.CurrencyPicker.convert("#ProductSection-" + ce + " .money")
            }, "html")
        }), $("#quick-view-modal").on("click", function (se) {
            var ie = se.target;
            0 >= $(ie).closest("div.product").length && I()
        })
    }

    function x() {
        y(), b(), k(), C(), T()
    }

    function P() {
        $(document).on("click", ".add_to_wishlist:not(.added)", function (se) {
            if (!$(this).hasClass("need-login")) {
                se.preventDefault();
                var ie = $(this),
                    re = ie.data("product_id"),
                    ne = ie.closest("form"),
                    le = {
                        action: "add_wishlist"
                    },
                    le = ne.serialize() + "&" + $.param(le);
                return $.ajax({
                    type: "POST",
                    url: "/a/wishlist",
                    async: !0,
                    cache: !1,
                    data: le,
                    dataType: "json",
                    beforeSend: function () {
                        ie.addClass("loading"), ie.attr("data-original-title", ie.attr("data-loading-text")).tooltip("fixTitle").tooltip("show")
                    },
                    error: function (de) {
                        console.log(de)
                    },
                    complete: function () {
                        ie.attr("data-original-title", ie.attr("data-added")).tooltip("fixTitle").tooltip("show"), ie.attr("data-original-title", ie.attr("data-success")), ie.addClass("added"), $(".wishlist" + re).addClass("added"), $(".wishlist" + re).attr("data-original-title", ie.attr("data-success")), setTimeout(function () {
                            ie.tooltip("hide")
                        }, 500)
                    },
                    success: function (de) {
                        ie.removeClass("loading"), $(".wishlist" + re + " > span").html($(".wishlist" + re).attr("data-success"));
                        $(".wishlist" + ie.prev().val());
                        0 < $(".menu-item-wishlist .mini-cart-counter").length && $(".menu-item-wishlist .mini-cart-counter").html(parseInt($(".menu-item-wishlist .mini-cart-counter").html()) + 1), 1 == de.code ? ($(".wishlist_items_number").text(de.json), jQuery("#rtp-message").html(ie.attr("data-added")), jQuery("#rt-unero-popup-message").css("margin-left", "-" + parseFloat(jQuery("#rt-unero-popup-message").width()) / 2 + "px").fadeIn(), window.setTimeout(function () {
                            jQuery("#rt-unero-popup-message").fadeOut()
                        }, 2e3)) : (alert(de.json), console.log(de.json))
                    }
                }), !1
            }
        })
    }

    function N() {
        $(".to-top").on("click", function () {
            return $("html, body").animate({
                scrollTop: 0
            }, 800), !1
        })
    }

    function B() {
        $(document).on("click", ".remove_from_wishlist", function (se) {
            se.preventDefault();
            var ie = $(this),
                re = ie.closest("form"),
                ne = {
                    action: "remove_wishlist"
                };
            return ne = re.serialize() + "&" + $.param(ne), $.ajax({
                type: "POST",
                url: "/a/wishlist",
                async: !0,
                cache: !1,
                data: ne,
                dataType: "json",
                beforeSend: function () {
                    $(".page-wishlist-content").addClass("loading")
                },
                error: function (le) {
                    console.log(le), $(".page-wishlist-content").removeClass("loading")
                },
                success: function (le) {
                    1 == le.code ? ie.closest("tr").slideUp("fast", function () {
                        ie.closest("tr").remove(), $(".page-wishlist-content .infos").removeClass("hide"), $(".wishlist_items_number").text(le.json), 0 == le.json && $(".wishlist-empty").removeClass("hide")
                    }) : (alert(le.json), console.log(le.json)), $(".page-wishlist-content").removeClass("loading"), 0 < $(".menu-item-wishlist .mini-cart-counter").length && $(".menu-item-wishlist .mini-cart-counter").html(parseInt($(".menu-item-wishlist .mini-cart-counter").html()) - 1)
                }
            }), !1
        })
    }

    function A() {
        jQuery("#be_compare_features_table").on("scroll", function () {
            var se = jQuery(this).parent();
            jQuery(this).scrollLeft() + jQuery(this).innerWidth() >= jQuery(this)[0].scrollWidth ? se.hasClass("scroll-right") && se.removeClass("scroll-right") : 0 === jQuery(this).scrollLeft() ? se.hasClass("scroll-left") && se.removeClass("scroll-left") : (!se.hasClass("scroll-right") && se.addClass("scroll-right"), !se.hasClass("scroll-left") && se.addClass("scroll-left"))
        }), be_compare_container = document.getElementById("be_compare_features_table"), null !== be_compare_container && be_compare_container.offsetWidth < be_compare_container.scrollWidth && !jQuery("#be_compare_features_table_inner").hasClass("scroll-right") && jQuery("#be_compare_features_table_inner").addClass("scroll-right"), jQuery(window).on("resize", function () {
            z()
        }), jQuery("#be_compare_features_table_inner").hasClass("scroll-left") || jQuery("#be_compare_features_table_inner").hasClass("scroll-right") ? $(".compare-preview").addClass("no-flex") : $(".compare-preview").removeClass("no-flex")
    }

    function z() {
        be_compare_container = document.getElementById("be_compare_features_table");
        null === be_compare_container || (be_compare_container.offsetWidth < be_compare_container.scrollWidth ? !jQuery("#be_compare_features_table_inner").hasClass("scroll-right") && jQuery("#be_compare_features_table_inner").addClass("scroll-right") : (jQuery("#be_compare_features_table_inner").hasClass("scroll-right") && jQuery("#be_compare_features_table_inner").removeClass("scroll-right"), jQuery("#be_compare_features_table_inner").hasClass("scroll-left") && jQuery("#be_compare_features_table_inner").removeClass("scroll-left")), jQuery("#be_compare_features_table_inner").hasClass("scroll-left") || jQuery("#be_compare_features_table_inner").hasClass("scroll-right") ? $(".compare-preview").addClass("no-flex") : $(".compare-preview").removeClass("no-flex"))
    }

    function D() {
        var se = $("body"),
            ie = $("a.add_to_compare"),
            re = "",
            le = !1;
        se.on("click", "a.add_to_compare", function () {
            var de = $(this),
                ce = de.data("pid"),
                pe = Currency.cookie.rtread("rt-compare"),
                ue = !1;
            if (le = !1, de.addClass("loading"), pe = null != pe && "" != pe ? pe.split(",") : [], de.hasClass("reach-limit") && (le = !0, !1 === $(this).hasClass("added") && (ue = !0, jQuery("#rtp-message").html(theme.strings.c_msg), jQuery("#rt-unero-popup-message").css("margin-left", "-" + parseFloat(jQuery("#rt-unero-popup-message").width()) / 2 + "px").fadeIn(), window.setTimeout(function () {
                    jQuery("#rt-unero-popup-message").fadeOut()
                }, 2e3))), 0 > pe.indexOf(ce) && !1 === $(this).hasClass("added") && !1 == le) {
                pe.push(ce);
                var me = pe.join(",");
                "," == me.substring(0, 1) && (me = me.substring(1)), Currency.cookie.rtwrite("rt-compare", me)
            }!1 === $(this).hasClass("added") || "" == re ? (re = "", $.ajax({
                url: "/pages/compare/" + pe,
                dataType: "html",
                type: "GET",
                success: function (ge) {
                    re = ge
                },
                error: function () {
                    console.log("ajax error"), de.removeClass("loading")
                },
                complete: function () {
                    pe.length >= parseInt(theme.compare_limit) && 0 < $("a.add_to_compare").length && $("a.add_to_compare").each(function () {
                        $(this).addClass("reach-limit")
                    }), $.magnificPopup.open({
                        items: {
                            src: re,
                            type: "inline"
                        },
                        preloader: !0,
                        tLoading: "",
                        mainClass: "compare-preview",
                        removalDelay: 200,
                        gallery: {
                            enabled: !0
                        },
                        callbacks: {
                            open: function () {
                                !1 == ue && ($("[data-pid=\"" + ce + "\"]").addClass("added").attr("data-original-title", $("[data-pid=\"" + ce + "\"]").attr("data-added")), $("[data-pid=\"" + ce + "\"]").find("span").html($("[data-pid=\"" + ce + "\"]").attr("data-added"))), de.removeClass("loading"), theme.CurrencyPicker.convert(".compare-content .money"), p(), A()
                            }
                        }
                    })
                }
            })) : $.ajax({
                url: "/pages/compare/" + pe,
                dataType: "html",
                type: "GET",
                success: function (ge) {
                    re = ge
                },
                error: function () {
                    console.log("ajax error"), de.removeClass("loading")
                },
                complete: function () {
                    $.magnificPopup.open({
                        items: {
                            src: re,
                            type: "inline"
                        },
                        preloader: !0,
                        tLoading: "",
                        mainClass: "compare-preview",
                        removalDelay: 200,
                        gallery: {
                            enabled: !0
                        },
                        callbacks: {
                            open: function () {
                                de.removeClass("loading"), theme.CurrencyPicker.convert(".compare-content .money"), p(), A()
                            }
                        }
                    })
                }
            })
        }), se.on("click", ".remove_from_compare", function (de) {
            de.preventDefault();
            var ce = $(this),
                pe = ce.attr("data-rev"),
                ue = $(".compare-content");
            $("[data-pid=\"" + pe + "\"]").removeClass("added").attr("data-original-title", $("[data-pid=\"" + pe + "\"]").attr("data-title")), $("[data-pid=\"" + pe + "\"]").find("span").html($("[data-pid=\"" + pe + "\"]").attr("data-title"));
            var me = decodeURI(Currency.cookie.rtread("rt-compare"));
            null != me && (me = me.split(","), me.length <= theme.compare_limit && 0 < $("a.add_to_compare").length && $("a.add_to_compare").each(function () {
                $(this).removeClass("reach-limit")
            })), me = jQuery.grep(me, function (ge) {
                return ge != pe
            }), me = $.trim(me), Currency.cookie.rtwrite("rt-compare", me), A(), $(".unero_" + pe).remove(), 0 >= me.length && $(".mfp-close").trigger("click")
        })
    }

    function U() {
        if (0 != parseInt(theme.compare)) {
            var se = Currency.cookie.rtread("rt-compare");
            null == se ? se = [] : (se = se.split(","), se.length >= parseInt(theme.compare_limit) && $(".add_to_compare").addClass("reach-limit"), se.map(function (ie) {
                $("[data-pid=\"" + ie + "\"]").addClass("added").attr("data-original-title", $("[data-pid=\"" + ie + "\"]").attr("data-added")), $("[data-pid=\"" + ie + "\"]").find("span").html($("[data-pid=\"" + ie + "\"]").attr("data-added"))
            }))
        }
    }

    function O() {
        "1" == theme.compare && (D(), U(), A())
    }

    function q() {
        $(document.body).find("img.lazy").lazyload({
            threshold: 1e3
        })
    }

    function M() {
        $(".add_to_wishlist").attr("data-original-title", $(".add_to_wishlist").html()).attr("rel", "tooltip"), $("[rel=tooltip]").tooltip({
            offsetTop: -15
        })
    }

    function V(se) {
        $(document.body).addClass("open-canvas-panel"), se.addClass("open")
    }

    function L() {
        $(document.body).removeClass("open-canvas-panel"), $(".unero-off-canvas-panel, #primary-mobile-nav, #primary-offcanvas-wrapper").removeClass("open")
    }

    function E() {
        $(document.body).on("click", ".cart-contents", function (se) {
            se.preventDefault(), V($("#cart-panel"))
        }), $(document.body).on("click", "#icon-menu-sidebar", function (se) {
            se.preventDefault(), V($("#menu-sidebar-menu-sidebar"))
        }), $(document.body).on("click", "#off-canvas-layer, .close-canvas-panel", function (se) {
            se.preventDefault(), L()
        })
    }

    function H() {
        $(document.body).on("click", "#menu-extra-search", function (se) {
            se.preventDefault(), S($("#search-modal")), $(this).addClass("show")
        }), $(document.body).on("click", ".close-modal", function (se) {
            se.preventDefault(), I()
        })
    }

    function F() {
        0 < $(".un-attr-swatches").length && $(".un-attr-swatches").each(function () {
            1 == $(this).find(".swatch").length && $(this).addClass("hide")
        }), $(".un-swatch-variation-image").click(function () {
            $(this).hasClass("selected") || ("" != $(this).attr("data-src") && $(this).closest(".product-inner").find(".product-item-image").attr("src", $(this).attr("data-src")), $(this).closest(".un-attr-swatches").find(".un-swatch-variation-image").removeClass("selected"), $(this).addClass("selected"))
        })
    }

    function R() {
        $(document.body).on("click", ".un-shop-view", function (se) {
            se.preventDefault();
            var ie = $(this),
                re = ie.data("view");
            ie.hasClass("current") || ($(document.body).find(".un-shop-view").removeClass("current"), ie.addClass("current"), $(document.body).removeClass("shop-view-grid shop-view-list").addClass("shop-view-" + re), $(document.body).trigger("unero_shop_view_after_change"))
        }), $(document.body).on("unero_shop_view_after_change", function () {
            q()
        })
    }

    function W() {
        var se = $("#un-shop-toolbar"),
            ie = $("#un-shop-topbar"),
            re = $("#un-categories-filter"),
            ne = se.find(".rt-unero-ordering"),
            le = $(".catalog-sidebar"),
            de = $(".catalog-offcanvas");
        $(window).on("resize", function () {
            991 > $(window).width() ? (se.addClass("on-mobile"), ie.addClass("on-mobile"), le.addClass("on-mobile"), de.addClass("on-mobile")) : (re.removeAttr("style"), $("#un-toggle-cats-filter").removeClass("active"), se.removeClass("on-mobile"), ie.removeClass("on-mobile"), le.removeClass("on-mobile"), de.removeClass("on-mobile"), ie.find(".widget-title").next().removeAttr("style"), le.find(".widget-title").next().removeAttr("style"))
        }).trigger("resize"), $(document.body).find(".shop-toolbar, .shop-bottombar").on("click", ".un-filter.filter-canvas", function (ce) {
            ce.preventDefault(), $("#primary-offcanvas-wrapper").toggleClass("open"), $(document.body).toggleClass("open-canvas-panel"), $(this).closest(".shop-toolbar").hasClass("on-mobile") && (re.slideUp(200), ne.slideUp(200), $("#un-toggle-cats-filter").removeClass("active"), $("#un-ordering").removeClass("active"), setTimeout(function () {
                ie.slideToggle(200)
            }, 200)), $(document.body).toggleClass("show-filters-content")
        }), 0 < $("#primary-offcanvas-wrapper").length && $("#primary-offcanvas-wrapper").on("click", ".close-canvas-shop-panel", function (ce) {
            ce.preventDefault(), L()
        }), $(document.body).find(".shop-toolbar, .shop-bottombar").on("click", ".un-filter:not(.filter-canvas)", function (ce) {
            ce.preventDefault(), $(this).closest(".shop-toolbar").hasClass("on-mobile") ? (re.slideUp(200), ne.slideUp(200), $("#un-toggle-cats-filter").removeClass("active"), $("#un-ordering").removeClass("active"), setTimeout(function () {
                ie.slideToggle(200)
            }, 200)) : ie.slideToggle(), ie.toggleClass("active"), $(this).toggleClass("active"), ie.closest(".shop-bottombar").toggleClass("show"), $("#un-filter-overlay").toggleClass("show"), $(document.body).toggleClass("show-filters-content")
        }), $(document.body).on("click", "#un-filter-overlay", function (ce) {
            ce.preventDefault(), ie.slideToggle(), $(".un-filter").removeClass("active"), ie.closest(".shop-bottombar").toggleClass("show"), $("#un-filter-overlay").toggleClass("show"), ie.removeClass("active"), $(document.body).removeClass("show-filters-content")
        }), $(document.body).on("click", "#un-toggle-cats-filter", function (ce) {
            ce.preventDefault(), $(this).closest(".shop-toolbar").hasClass("on-mobile") && (ie.slideUp(200), setTimeout(function () {
                re.slideToggle(200)
            }, 200), $(this).toggleClass("active"), $(".un-filter").removeClass("active"), ie.removeClass("active"))
        }), $(document.body).on("click", "#un-ordering", function (ce) {
            ce.preventDefault(), $(this).closest(".shop-toolbar").hasClass("on-mobile") && (ie.slideUp(200), setTimeout(function () {
                ne.slideToggle(200)
            }, 200), $(this).toggleClass("active"), $(".un-filter").removeClass("active"), ie.removeClass("active"))
        }), ie.on("click", ".widget-title", function (ce) {
            $(this).closest(".shop-topbar").hasClass("on-mobile") && (ce.preventDefault(), $(this).closest(".widget").siblings().find(".widget-title").next().slideUp(200), $(this).closest(".widget").siblings().removeClass("active"), $(this).next().slideToggle(200), $(this).closest(".widget").toggleClass("active"))
        }), le.on("click", ".widget-title", function (ce) {
            $(this).closest(".catalog-sidebar").hasClass("on-mobile") && (ce.preventDefault(), $(this).closest(".widget").siblings().find(".widget-title").next().slideUp(200), $(this).closest(".widget").siblings().removeClass("active"), $(this).next().slideToggle(200), $(this).closest(".widget").toggleClass("active"))
        }), de.on("click", ".widget-title", function (ce) {
            $(this).closest(".catalog-offcanvas").hasClass("on-mobile") && (ce.preventDefault(), $(this).closest(".widget").siblings().find(".widget-title").next().slideUp(200), $(this).closest(".widget").siblings().removeClass("active"), $(this).next().slideToggle(200), $(this).closest(".widget").toggleClass("active"))
        })
    }

    function G() {
        $(document.body).hasClass("catalog-board-content") && $(document.body).imagesLoaded(function () {
            $("#un-shop-content").find("ul.products").isotope({
                itemSelector: "li.product",
                layoutMode: "masonry"
            })
        })
    }

    function K() {
        $(document.body).hasClass("collection-metro-content") && $(document.body).imagesLoaded(function () {
            $("#un-shop-content").find("ul.products").isotope({
                itemSelector: "li.product",
                layoutMode: "masonry"
            })
        })
    }

    function Q() {
        $("#unero-site-content").hasClass("blog-layout-masonry") && $(document.body).imagesLoaded(function () {
            $("#unero-site-content").find(".unero-post-list").isotope({
                itemSelector: ".un-post-item",
                layoutMode: "masonry"
            })
        })
    }

    function Y() {
        if ($(document.body).hasClass("portfolio-layout-carousel")) {
            var se = $("#unero-site-content"),
                ie = se.find(".unero-post-frame"),
                re = 2,
                ne = 0,
                le = 5e3;
            0 < re && --re, 0 < ne ? (le = ne, ne = 1) : ne = 0;
            var de = {
                    horizontal: 1,
                    smart: 1,
                    itemNav: "forceCentered",
                    activateOn: "click",
                    touchDragging: 1,
                    mouseDragging: 1,
                    releaseSwing: 1,
                    startAt: re,
                    scrollBar: se.find(".scrollbar"),
                    speed: 1e3,
                    elasticBounds: 1,
                    dragHandle: 1,
                    dynamicHandle: 1,
                    clickBar: 1,
                    cycleBy: "items",
                    cycleInterval: le,
                    pauseOnHover: ne
                },
                ce = new Sly(ie, de);
            ce.on("load move", function () {
                se.addClass("loaded")
            }), ce.init(), $(window).resize(function () {
                var pe = $(window).width(),
                    ue = pe - 60;
                $(document.body).hasClass("boxed") && (pe = $(".site").width()), 1024 > pe && (ue = pe - 30), 1200 > pe ? $(".portfolio-layout-carousel").find(".portfolio-wapper").width(ue) : $(".portfolio-layout-carousel").find(".portfolio-wapper").removeAttr("style"), ce.reload()
            }).trigger("resize")
        }
    }

    function Z() {
        if ($("#content").hasClass("animation-product")) {
            var se = $(document.body).find("#un-shop-content .product-inner");
            se.removeAttr("data-sr-id").removeAttr("style");
            window.sr = new ScrollReveal({
                viewFactor: 0.15,
                duration: 1e3,
                scale: 0.9,
                opacity: 1,
                easing: "ease"
            });
            sr.reveal(se, {
                reset: !0,
                viewOffset: {
                    top: 64
                }
            })
        }
    }

    function J() {
        if (!$(".page-header").hasClass("page-header-sliders")) return void $(".page-header.parallax").parallax("50%", 0.6);
        var se = $(".page-header-sliders"),
            ie = se.data("speed"),
            re = !1,
            ne = se.data("auto"),
            le = se.data("parallax");
        if ("1" == le && (re = !0), se.find("ul").not(".slick-initialized").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: !0,
                autoplaySpeed: ie,
                autoplay: ne,
                fade: re,
                cssEase: "linear",
                prevArrow: "<span class=\"icon-chevron-left slick-prev-arrow\"></span>",
                nextArrow: "<span class=\"icon-chevron-right slick-next-arrow\"></span>"
            }), "0" == le) $(".page-header-sliders.parallax").find("li").parallax("50%", 0.6);
        else {
            var de = se.height();
            $(document.body).hasClass("admin-bar") && (de -= 32), $("#content").css("margin-top", de), se.addClass("parallax-2"), $(window).on("scroll", function () {
                var ce = $(window).scrollTop();
                0 < ce ? $(".page-header-sliders.parallax-2").css({
                    opacity: (de - ce) / de
                }) : $(".page-header-sliders.parallax-2").css({
                    opacity: 1
                })
            })
        }
    }

    function X() {
        var se = parseInt(theme.popup_mailchimp_show);
        if (0 < se) {
            function de() {
                $(document.body).removeClass("modal-open");
                var ce = $(".popup-modal.open");
                ce.fadeOut(function () {
                    $(this).removeClass("open")
                }), $(document.body).trigger("roar_modal_closed", [ce])
            }
            var ie = parseInt(theme.popup_mailchimp_period),
                re = parseInt(theme.popup_mailchimp_delay);
            if (0 < ie && document.cookie.match(/^(.*;)?\s*unero_popup\s*=\s*[^;]+(.*)?$/)) return;
            re = Math.max(re, 0), $(window).on("load", function () {
                setTimeout(function () {
                     $(".popup-modal").fadeIn(), $(".popup-modal").addClass("open")
                }, 1e3 * re)
            }), $(document.body).on("roar_modal_closed", function (ce, pe) {
                if (pe.hasClass("roar-popup")) {
                    var ue = new Date,
                        me = ue.getTime();
                    ue.setTime(ue.getTime() + 1e3 * (60 * (60 * (24 * ie)))), document.cookie = "unero_popup=" + me + ";expires=" + ue.toGMTString() + ";path=/"
                }
            });
            var ne = $("#mc-form.newsletter"),
                le = ne.attr("action");
            ne.ajaxChimp({
                url: le,
                callback: function (ce) {
                    "success" === ce.result && de()
                }
            }), $(document.body).on("click", ".close-modal, .popup-backdrop", function (ce) {
                ce.preventDefault(), de()
            }), $(document).on("keyup", function (ce) {
                27 === ce.keyCode && de()
            })
        }
    }

    function ee() {
        $(window).on("load", function () {
            "undefined" != typeof window.notifySettings && (notifyProIO.settings = {}, notifyProIO.settings.message = window.notifySettings.message, notifyProIO.settings.hideMobile = !0, notifyProIO.settings.initialDelay = 3e3, notifyProIO.settings.displayInterval = window.notifySettings.displayInterval, notifyProIO.settings.displayHold = window.notifySettings.displayHold, notifyProIO.settings.totalPerPage = window.notifySettings.totalPerPage, notifyProIO.settings.totalDisplayed = 0, notifyProIO.settings.loop = !0, notifyProIO.setup(window.notifyProducts))
        })
    }

    function te() {
        return document.cookie.match(/^(.*;)?\s*unero_cookie\s*=\s*[^;]+(.*)?$/) ? void $(".cc_container").remove() : void($(window).on("load", function () {
            setTimeout(function () {
                $(".cc_container").addClass("open")
            }, 5e3)
        }), $(".cc_btn").click(function (se) {
            se.preventDefault();
            var ie = new Date,
                re = ie.getTime();
            ie.setTime(ie.getTime() + 31536000000), document.cookie = "unero_cookie=" + re + ";expires=" + ie.toGMTString() + ";path=/", $(".cc_container").removeClass("open")
        }))
    }

    function ae() {
        $().countdown && 0 < $(".countdown-item").length && $(".countdown-item").each(function () {
            if ("" != $(this).data("countdown")) {
                var se = new Date,
                    ie = $(this).data("countdown").split("-"),
                    ie = new Date(ie[2], parseInt(ie[0]) - 1, ie[1]);
                se < ie && $(this).countdown({
                    until: ie,
                    layout: "<span class=\"countdown-day\">{dn}d</span><span class=\"countdown-hour\">{hn}h</span><span class=\"countdown-minute\">{mn}m</span><span class=\"countdown-second\">{sn}s</span>"
                })
            }
        })
    }

    function oe() {
        $(document.body).hasClass("header-mixed-content") && $(".site-content .shopify-section").first().css("margin-top", -$(".site-header").height())
    }
    return {
        init: function () {
            W(), R(), q(), M(), P(), B(), p(), ae(), F(), x(), H(), E(), Z(), G(), K(), Q(), Y(), J(), N(), X(), ee(), te(), O(), oe()
        },
        pageHeader: function () {
            J()
        },
        initLoadMore: function () {
            q(), M(), p(), ae(), Z(), F(), G(), K(), Q()
        }
    }
}(), theme.init = function () {
    theme.roarApplication.init(), theme.customerTemplates.init(), slate.rte.wrapTable(), slate.rte.iframeReset(), slate.a11y.pageLinkFocus($(window.location.hash)), $(".in-page-link").on("click", function (p) {
        slate.a11y.pageLinkFocus($(p.currentTarget.hash))
    }), $("a[href=\"#\"]").on("click", function (p) {
        p.preventDefault()
    })
};
try {
    $(theme.init)
} finally {
    var $unloader = $("#un-before-unloader");
    $(window).on("beforeunload", function () {
        $unloader.removeClass("out").fadeIn(500, function () {
            $unloader.addClass("loading")
        })
    }), $unloader.fadeOut(200, function () {
        $unloader.addClass("out")
    })
}